const {
    limpaMoeda,
    isEmpty,
    debounce,
} = require("./default_parts/functions/miscellaneous");
const {
    buscarFasePipelines,
    atualizaHtmlCardOportunidadeKanban,
    buscarTiposAtendimentoPorPipeline
} = require("./default_parts/functions/ajax_requests")

const functions = require("./default_parts/functions").default;

/**
 * Abre oportunidade/cliente na modal fullscreen (iframe) e empilha histórico no pai.
 * O "voltar" do navegador (popstate) fecha a modal em vez de navegar a página.
 */
if (!window.__elocaOportunidadeModalPopstate) {
    window.__elocaOportunidadeModalPopstate = true;
    window.addEventListener("popstate", function () {
        const jq = window.jQuery || window.$;
        if (!jq) {
            return;
        }
        const modal = jq("#modalOportunidadeFullscreen");
        if (!modal.length || !modal.hasClass("show")) {
            return;
        }
        jq("#iframeOportunidadeFullscreen").attr("src", "");
        modal.modal("hide");
    });
}

const ELOCA_CARTEIRA_KANBAN_REFRESH_STORAGE_KEY = "eloca:carteira-kanban-refresh";

window.elocaKanbanResolverClienteIdParaKanban = function (detail) {
    detail = detail || {};
    const ctx = window.elocaCarteiraKanbanContext || {};
    let clienteId =
        detail.clienteId ||
        detail.clientePaiId ||
        ctx.clientePaiId ||
        ctx.clienteId;
    if (!clienteId) {
        const match = String(window.location.pathname || "").match(
            /\/painel\/clientes\/(\d+)/,
        );
        if (match) {
            clienteId = Number(match[1]);
        }
    }
    const id = Number(clienteId);
    return Number.isFinite(id) && id > 0 ? id : null;
};

/**
 * Avisa o Kanban da carteira (pai) para atualizar o card da conta após edição no iframe.
 */
window.elocaNotificarCarteiraKanbanAtualizar = function (detail) {
    const clienteId = window.elocaKanbanResolverClienteIdParaKanban(detail);
    if (!clienteId) {
        return;
    }
    const payload = {
        type: "elocaCarteiraKanbanAtualizar",
        clienteId,
    };
    try {
        localStorage.setItem(
            ELOCA_CARTEIRA_KANBAN_REFRESH_STORAGE_KEY,
            JSON.stringify({ clienteId, ts: Date.now() }),
        );
    } catch (err) {
        /* ignore */
    }
    if (window.parent && window.parent !== window) {
        try {
            window.parent.postMessage(payload, "*");
        } catch (err) {
            /* ignore */
        }
    }
    if (window.opener && !window.opener.closed) {
        try {
            window.opener.postMessage(payload, "*");
        } catch (err) {
            /* ignore */
        }
    }
};

window.elocaKanbanNotificarRefreshSeSolicitado = function () {
    const params = new URLSearchParams(window.location.search);
    if (params.get("carteira_kanban_refresh") !== "1") {
        return;
    }
    if (typeof window.elocaNotificarCarteiraKanbanAtualizar === "function") {
        window.elocaNotificarCarteiraKanbanAtualizar();
    }
    params.delete("carteira_kanban_refresh");
    const qs = params.toString();
    const newSearch = qs ? "?" + qs : "";
    const newUrl =
        window.location.pathname + newSearch + (window.location.hash || "");
    try {
        history.replaceState(history.state, document.title, newUrl);
    } catch (err) {
        /* ignore */
    }
};

if (!window.__elocaCarteiraKanbanAjaxNotify) {
    window.__elocaCarteiraKanbanAjaxNotify = true;
    let carteiraKanbanNotifyTimer = null;
    $(document).ajaxSuccess(function (_event, _xhr, settings) {
        const emIframeKanban =
            window.parent &&
            window.parent !== window &&
            window.elocaCarteiraKanbanContext;
        if (
            window.location.search.indexOf("kanban_modal") === -1 &&
            !emIframeKanban
        ) {
            return;
        }
        if (!window.elocaCarteiraKanbanContext && !emIframeKanban) {
            return;
        }
        const url = (settings && settings.url) || "";
        if (
            !/\/painel\/(oportunidades|clientes|oportunidades-tarefas|carteira\/kanban\/cliente)\//.test(
                url
            )
        ) {
            return;
        }
        const method = ((settings && settings.type) || "GET").toUpperCase();
        if (!/^(POST|PUT|PATCH|DELETE)$/.test(method)) {
            return;
        }
        clearTimeout(carteiraKanbanNotifyTimer);
        carteiraKanbanNotifyTimer = setTimeout(function () {
            if (typeof window.elocaNotificarCarteiraKanbanAtualizar === "function") {
                window.elocaNotificarCarteiraKanbanAtualizar();
            }
        }, 450);
    });
}

window.elocaModalIframePainelShowLoading = function (jq) {
    if (!jq) {
        return;
    }
    jq("#iframeOportunidadeFullscreenLoading").removeClass("d-none");
};

window.elocaModalIframePainelHideLoading = function (jq) {
    if (!jq) {
        return;
    }
    jq("#iframeOportunidadeFullscreenLoading").addClass("d-none");
};

window.elocaAbrirModalIframePainel = function (fullUrl) {
    try {
        if (
            window.parent &&
            window.parent !== window &&
            window.location.search.indexOf("kanban_modal") !== -1
        ) {
            if (typeof window.parent.elocaAbrirModalIframePainel === "function") {
                window.parent.elocaAbrirModalIframePainel(fullUrl);
                return;
            }
            try {
                window.parent.postMessage(
                    { type: "elocaKanbanIframeNavigateStart" },
                    "*",
                );
            } catch (postErr) {
                /* ignore */
            }
            window.location.href = fullUrl;
            return;
        }
    } catch (err) {
        /* ignore */
    }

    const jq = window.jQuery || window.$;
    if (!jq) {
        window.location.href = fullUrl;
        return;
    }
    const iframe = jq("#iframeOportunidadeFullscreen");
    const modal = jq("#modalOportunidadeFullscreen");
    if (!iframe.length || !modal.length) {
        window.location.href = fullUrl;
        return;
    }
    if (window.history && window.history.pushState) {
        try {
            const state = { elocaOportunidadeModal: true };
            if (modal.hasClass("show")) {
                history.replaceState(
                    state,
                    document.title,
                    window.location.href,
                );
            } else {
                history.pushState(
                    state,
                    document.title,
                    window.location.href,
                );
            }
        } catch (err) {
            /* ignore */
        }
    }
    window.elocaModalIframePainelShowLoading(jq);
    iframe.off("load.elocaModalIframe").on("load.elocaModalIframe", function () {
        window.elocaModalIframePainelHideLoading(jq);
    });
    iframe.attr("src", fullUrl);
    modal.modal("show");
};

Eloca.behaviors.oportunidades = function (context) {
    if (typeof window.elocaKanbanNotificarRefreshSeSolicitado === "function") {
        window.elocaKanbanNotificarRefreshSeSolicitado();
    }

    $(".js-kanban-acoes-dropdown", context)
        .off(".kanbanAcoesDropdown")
        .on("show.bs.dropdown.kanbanAcoesDropdown", function () {
            const $menu = $(this).children(".dropdown-menu");
            $(this).data("kanbanDropdownMenu", $menu);
            $menu.appendTo(document.body);
        })
        .on("shown.bs.dropdown.kanbanAcoesDropdown", function () {
            const $toggle = $(this).find('[data-toggle="dropdown"]');
            const $menu = $(this).data("kanbanDropdownMenu");
            if (!$toggle.length || !$menu || !$menu.length) {
                return;
            }
            const rect = $toggle[0].getBoundingClientRect();
            $menu.css({
                position: "fixed",
                top: rect.top,
                left: Math.max(8, rect.left - $menu.outerWidth()),
                right: "auto",
                transform: "none",
                zIndex: 1040,
            });
        })
        .on("hide.bs.dropdown.kanbanAcoesDropdown", function () {
            const $menu = $(this).data("kanbanDropdownMenu");
            if (!$menu || !$menu.length) {
                return;
            }
            $menu.appendTo(this);
            $menu.css({
                position: "",
                top: "",
                left: "",
                right: "",
                transform: "",
                zIndex: "",
            });
        });

    /**
     * Dentro do iframe da modal do kanban, após redirect com ?kanban_modal_close=1 o pai não
     * consegue ler location do iframe de forma confiável; o filho avisa por postMessage.
     * Usa targetOrigin '*' porque em alguns ambientes (ex.: www vs não-www, CDN/S3 só nos assets)
     * a origem do iframe pode não coincidir com a do pai e a mensagem era descartada.
     * O pai valida com event.source === iframe.contentWindow.
     */
    try {
        if (window.parent && window.parent !== window) {
            const params = new URLSearchParams(window.location.search);
            if (params.get("kanban_modal_close") === "1") {
                window.parent.postMessage(
                    { type: "elocaKanbanOportunidadeFechar" },
                    "*"
                );
            }
        }
    } catch (e) {
        /* ignore */
    }

    /**
     * Iframe (?kanban_modal=1): abas com hash (oportunidade, cliente, score, etc.) usam
     * replaceState para não empilhar histórico; popstate só fecha a modal ao sair da página.
     */
    try {
        if (
            window.parent &&
            window.parent !== window &&
            window.location.search.indexOf("kanban_modal") !== -1 &&
            window.location.search.indexOf("kanban_modal_close") === -1 &&
            !window.__elocaKanbanModalIframeSetup
        ) {
            window.__elocaKanbanModalIframeSetup = true;

            function elocaKanbanModalIframeUrl() {
                return (
                    window.location.pathname +
                    window.location.search +
                    (window.location.hash || "")
                );
            }

            function elocaKanbanModalAindaNaPagina() {
                if (window.location.search.indexOf("kanban_modal") === -1) {
                    return false;
                }
                const path = window.location.pathname;
                return (
                    /\/painel\/oportunidades\/\d+/.test(path) ||
                    /\/painel\/clientes\/\d+/.test(path)
                );
            }

            $(document).on(
                "click",
                'a[data-toggle="tab"][href^="#"]',
                function (e) {
                    const href = $(this).attr("href");
                    if (!href || href.charAt(0) !== "#") {
                        return;
                    }
                    e.preventDefault();
                    $(this).tab("show");
                    if (window.history && window.history.replaceState) {
                        try {
                            history.replaceState(
                                { elocaKanbanModalIframe: true },
                                document.title,
                                window.location.pathname +
                                    window.location.search +
                                    href,
                            );
                        } catch (err) {
                            /* ignore */
                        }
                    }
                },
            );

            if (window.history && window.history.replaceState) {
                try {
                    history.replaceState(
                        { elocaKanbanModalIframe: true },
                        document.title,
                        elocaKanbanModalIframeUrl(),
                    );
                } catch (err) {
                    /* ignore */
                }
            }

            window.addEventListener("popstate", function () {
                if (elocaKanbanModalAindaNaPagina()) {
                    if (window.history && window.history.replaceState) {
                        try {
                            history.replaceState(
                                { elocaKanbanModalIframe: true },
                                document.title,
                                elocaKanbanModalIframeUrl(),
                            );
                        } catch (err) {
                            /* ignore */
                        }
                    }
                    return;
                }
                try {
                    window.parent.postMessage(
                        { type: "elocaKanbanOportunidadeFechar" },
                        "*",
                    );
                } catch (err) {
                    /* ignore */
                }
            });
        }
    } catch (e) {
        /* ignore */
    }

    const FECHAR_MODAL_AJAX_APOS_EXCLUIR_MS = 3000;

    function fecharKanbanAposAjaxOportunidade(msgSucesso, $modalInterno) {
        $modalInterno.modal("hide");

        const emIframe = window.parent && window.parent !== window;
        let docPai = null;
        if (!emIframe) {
            docPai = document;
        } else {
            try {
                docPai = window.parent.document;
            } catch (e) {
                docPai = null;
            }
        }

        if (docPai) {
            const iframeKanban = docPai.getElementById(
                "iframeOportunidadeFullscreen",
            );
            const modalKanban = docPai.getElementById(
                "modalOportunidadeFullscreen",
            );
            let parentJquery = null;
            try {
                parentJquery = emIframe ? window.parent.$ : window.$;
            } catch (e) {
                parentJquery = null;
            }
            if (
                iframeKanban &&
                modalKanban &&
                parentJquery &&
                parentJquery.fn &&
                parentJquery.fn.modal
            ) {
                iframeKanban.setAttribute("src", "");
                parentJquery(modalKanban).modal("hide");
                return;
            }
        }

        if (emIframe) {
            try {
                window.parent.postMessage(
                    {
                        type: "elocaKanbanOportunidadeFechar",
                        alertMessage: msgSucesso,
                    },
                    "*",
                );
            } catch (e) {
                /* ignore */
            }
        }
        showToastSuccess(context, msgSucesso);
    }

    $(document).on("submit", "form.js-oportunidade-destroy-ajax", function (e) {
        e.preventDefault();
        const $form = $(this);
        const $modal = $form.find(".modal");
        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: $form.attr("action"),
            type: "POST",
            data: $form.serialize(),
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (res.error) {
                    showToastDanger(
                        context,
                        res.message || "Erro ao excluir.",
                    );
                    return;
                }
                window.setTimeout(function () {
                    fecharKanbanAposAjaxOportunidade(
                        res.message || "Item excluído com sucesso.",
                        $modal,
                    );
                }, FECHAR_MODAL_AJAX_APOS_EXCLUIR_MS);
            },
            error: function (xhr) {
                $("#overlayer-loading").removeClass("show-overlayer");
                const json = xhr.responseJSON;
                let msg = "Erro ao excluir.";
                if (json) {
                    if (typeof json.message === "string") {
                        msg = json.message;
                    } else if (json.errors) {
                        msg = Object.values(json.errors).flat().join(" ");
                    }
                }
                showToastDanger(context, msg);
            },
        });
    });

    $(document).on("submit", "form.js-oportunidade-transfere-ajax", function (e) {
        e.preventDefault();
        const $form = $(this);
        //const $modal = $form.closest(".modal");
        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: $form.attr("action"),
            type: "POST",
            data: $form.serialize(),
            dataType: "json",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (res.error) {
                    showToastDanger(
                        context,
                        res.message || "Erro ao transferir.",
                    );
                    return;
                }
                const msg =
                    res.message || "Oportunidade transferida com sucesso.";
                showToastSuccess(context, msg);
                if (window.parent && window.parent !== window) {
                    try {
                        window.parent.location.reload();
                    } catch (err) {
                        window.location.reload();
                    }
                } else {
                    window.location.reload();
                }
            },
            error: function (xhr) {
                $("#overlayer-loading").removeClass("show-overlayer");
                const json = xhr.responseJSON;
                let msg = "Erro ao transferir.";
                if (json) {
                    if (typeof json.message === "string") {
                        msg = json.message;
                    } else if (json.errors) {
                        msg = Object.values(json.errors).flat().join(" ");
                    }
                }
                showToastDanger(context, msg);
            },
            complete: function () {
                $form.find("button").prop("disabled", false);
            },
        });
    });

    if ($("#kanban", context).length) {
        const ids = $("#kanban", context).data("ids");
        const url = $("#kanban", context).data("url");
        const isKanbanV2 = Boolean($("#kanban", context).data("kanban-v2"));
        if ($("#kanban", context).data("ids")) {
            const limparHelperDragKanban = function () {
                $("ul.kanban-drag-helper").remove();
                $("li.kanban-drag-helper-item").remove();
            };

            const manterUnicoCardKanban = function (oportunidadeId, $keep) {
                if (oportunidadeId == null || oportunidadeId === "") {
                    return;
                }
                const $cards = $(`li.js-op-${oportunidadeId}`);
                const keepNoDom =
                    $keep &&
                    $keep.length &&
                    $keep[0] &&
                    document.body.contains($keep[0]);
                if (keepNoDom) {
                    $cards.not($keep).remove();
                    return;
                }
                $cards.slice(1).remove();
            };

            const devolverCardKanbanOrigem = function ($item, $origem, indiceOrigem) {
                if (!$item || !$item.length || !$origem || !$origem.length) {
                    return;
                }

                $item.show().css({
                    display: "",
                    visibility: "",
                    opacity: "",
                    height: "",
                    width: "",
                });

                const $filhos = $origem.children("li").not($item);
                if (
                    typeof indiceOrigem === "number" &&
                    indiceOrigem >= 0 &&
                    indiceOrigem < $filhos.length
                ) {
                    $item.insertBefore($filhos.eq(indiceOrigem));
                } else {
                    $origem.append($item);
                }

                manterUnicoCardKanban($item.data("id"), $item);
                limparHelperDragKanban();

                if ($origem.hasClass("ui-sortable")) {
                    $origem.sortable("refresh");
                }
            };

            const sortableOptions = {
                connectWith: ".connectedSortable",
                start: function (event, ui) {
                    ui.item.data("kanban-origem", ui.item.parent());
                    ui.item.data("kanban-origem-index", ui.item.index());
                    if (isKanbanV2) {
                        ui.placeholder.height(ui.item.outerHeight());
                    }
                },
                receive: function (event, ui) {
                    const oportunidadeId = $(ui.item[0]).data("id");
                    const faseId = $(event.target).data("id");
                    const $item = $(ui.item[0]);
                    const $destino = $(event.target);
                    const $origem =
                        ui.sender && ui.sender.length
                            ? ui.sender
                            : $item.data("kanban-origem");
                    const indiceOrigem = $item.data("kanban-origem-index");

                    const oportunidades = [];
                    $destino.children("li.oportunidade").not(".kanban-drag-helper-item").each(function (index, li) {
                        oportunidades.push({
                            id: $(li).data("id"),
                            ordem: index + 1,
                        });
                    });
                    $.ajax({
                        url: url,
                        type: "put",
                        xhrFields: {
                            withCredentials: true
                        },
                        data: {
                            id: oportunidadeId,
                            fase_id: faseId,
                            oportunidades: oportunidades,
                        },
                        headers: {
                            "X-CSRF-TOKEN": $(
                                'meta[name="csrf-token"]'
                            ).attr("content"),
                        },
                        success: function (res) {
                            if (res && res.error) {
                                devolverCardKanbanOrigem(
                                    $item,
                                    $origem,
                                    indiceOrigem
                                );
                                if ($destino.hasClass("ui-sortable")) {
                                    $destino.sortable("refresh");
                                }
                                const nomes = (res.campos_pendentes || [])
                                    .map(function (campo) {
                                        return campo.nome;
                                    })
                                    .filter(Boolean);
                                let msg =
                                    res.message ||
                                    "Para avançar esta oportunidade é necessário preencher todos os campos obrigatórios desta etapa.";
                                if (nomes.length) {
                                    msg += " Pendentes: " + nomes.join(", ");
                                }
                                showToastDanger(context, msg);
                                destacarCamposPendentesFase(
                                    context,
                                    res.campos_pendentes || []
                                );
                                somaOportunidades();
                                $(document).trigger("eloca:kanban-cards-changed");
                                return;
                            }
                            manterUnicoCardKanban(oportunidadeId, $item);
                            limparHelperDragKanban();
                            atualizaHtmlCardOportunidadeKanban(oportunidadeId);
                            somaOportunidades();
                        },
                        error: function () {
                            devolverCardKanbanOrigem(
                                $item,
                                $origem,
                                indiceOrigem
                            );
                            if ($destino.hasClass("ui-sortable")) {
                                $destino.sortable("refresh");
                            }
                            showToastDanger(
                                context,
                                "Erro ao atualizar a fase da oportunidade"
                            );
                            somaOportunidades();
                            $(document).trigger("eloca:kanban-cards-changed");
                        },
                    });
                },
            };

            if (isKanbanV2) {
                Object.assign(sortableOptions, {
                    appendTo: "body",
                    forcePlaceholderSize: true,
                    helper: function (e, item) {
                        const $clone = item.clone();
                        $clone.removeClass(function (_i, cls) {
                            return (String(cls).match(/(^|\s)js-op-\S+/g) || []).join(
                                " "
                            );
                        });
                        $clone.removeAttr("data-id");
                        $clone.addClass("kanban-drag-helper-item");
                        const $wrapper = $(
                            '<ul class="lista-oportunidades kanban-drag-helper"></ul>'
                        );
                        $wrapper.append($clone);
                        $wrapper.width(item.outerWidth());
                        return $wrapper;
                    },
                    stop: function () {
                        limparHelperDragKanban();
                    },
                });
            }

            $(ids)
                .sortable(sortableOptions)
                .disableSelection();
        }
        somaOportunidades();
        ordenaOportunidades();
    }

    if ($("#minhas-oportunidades", context).length) {
        somaOportunidades();
        ordenaOportunidades();
    }

    if ($("#kanban", context).length || $("#minhas-oportunidades", context).length) {
        $(document)
            .off("eloca:kanban-cards-changed.kanbanTotals")
            .on("eloca:kanban-cards-changed.kanbanTotals", function () {
                if (
                    $("#kanban", context).length ||
                    $("#minhas-oportunidades", context).length
                ) {
                    somaOportunidades();
                    ordenaOportunidades();
                }
            });
    }

    const alturaBlocoChat = function () {
        const isKanbanModal =
            document.body.classList.contains("kanban-modal-pagina") ||
            window.location.search.indexOf("kanban_modal") !== -1;
        // Modal iframe: sem navbar (59). Página cheia / nova aba: navbar + abas (105).
        return $(window).height() - (isKanbanModal ? 59 : 105);
    };

    $(".js-bloco-chat-interno").attr(
        "style",
        "min-height:" + alturaBlocoChat().toString() + "px;"
    );

    $(".js-mensagens-filtradas").css("height", ($(window).height() - 207).toString() + "px");

     $(window).on("resize", function () {
        $(".js-mensagens-filtradas").css("height", ($(window).height() - 207).toString() + "px");
     });


    function scrollParaBuscarMensagensChat(e, time, tentativas) {
        setTimeout(function () {
            const link = e.target.closest("a");
            if (link && link.getAttribute("href")?.startsWith("#js-mensagem-")) {
                e.preventDefault();
                const targetId = link.getAttribute("href").substring(1);
                const el = document.getElementById(targetId);
                const newContext = $(
                    $(".js-aba-chat.active", context).data("tab"),
                    context
                );
                const container = $(".js-container-chat", newContext);
                if (!el) {
                    $("#overlayer-loading").addClass("show-overlayer");
                    container.scrollTop(0);
                    loadingChat(newContext, container);
                    time = 4000;
                    tentativas++;
                    if (tentativas > 70) {
                        $("#overlayer-loading").removeClass("show-overlayer");
                        return;
                    }
                    scrollParaBuscarMensagensChat(e, time, tentativas);
                } else if (link.getAttribute("href")?.startsWith("#js-mensagem-")) {
                    if (container.length && $(el).length) {
                        const scrollTo = $(el).offset().top - container.offset().top + container.scrollTop();
                        container.animate({ scrollTop: scrollTo }, 400);
                        setTimeout(function () {
                            $(el).addClass("mensagem--encontrada");
                            setTimeout(function () {
                                $(el).removeClass("mensagem--encontrada");
                            }, 1800);
                        }, 1000);
                    }
                    $("#overlayer-loading").removeClass("show-overlayer");
                }
            }
        }, time);
    }
    
    document.addEventListener('click', function(e) {
        scrollParaBuscarMensagensChat(e, 0, tentativas = 0);
    });

    $(".js-bloco-chat, .js-bloco-midias, .js-linha-chat").height(
        alturaBlocoChat()
    );
    $(window).on("resize", function () {
        $(".js-bloco-chat, .js-bloco-midias, .js-linha-chat").height(
            alturaBlocoChat()
        );

        $(".js-bloco-chat-interno").attr(
            "style",
            "min-height:" + alturaBlocoChat().toString() + "px;"
        );
    });

    $(".js-add-oportunidade", context).on("click", function () {
        let faseId = $(this).data("fase-id");
        const modal = $("#modalNovaOportunidade", context);
        if (!faseId) {
            faseId = $("#fase_id option", modal)[0].value;
        }
        $("#fase_id", modal).val(faseId);
    });

    $(".js-autocomplete-cliente", context).each(function () {
        const input = this;
        let novo = true;
        if ($(this).data('novo') == false) {
            novo = false;
        }
        $(this).on("keyup", function () {
            if (this.value.length == 0) {
                $(input)
                    .closest(".form-group")
                    .find(".js-input-autocomplete")
                    .val("");
                getLocacao();
            }
        });

        $(input)
            .autocomplete({
                source: function (request, response) {
                    $.ajax({
                        url: siteUrl("/painel/clientes/busca/autocomplete"),
                        data: {
                            term: request.term
                        },
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function (data) {
                            response(data);
                        }
                    });
                },
                minLength: 2,
                select: function select(event, ui) {
                    if (ui.item.noResult && novo) {
                        setNovoCliente(input.value);
                        getLocacao();
                    } else {
                        setTimeout(function () {
                            $(input)
                                .closest(".form-group")
                                .find(".js-input-autocomplete")
                                .val(ui.item.id);
                            $(input).val(ui.item.nome);
                        }, 1);
                        getLocacao(ui.item.id);
                    }
                },
                response: function (event, ui) {
                    if (ui.content.length < 10 && novo) {
                        var noResult = { noResult: true };
                        ui.content.push(noResult);
                    }
                },
            })
            .autocomplete("instance")._renderItem = function (ul, item) {
                $(ul).css({
                    "z-index": 2000,
                    "max-height": "300px",
                    "overflow-y": "auto",
                });
                $(ul).addClass("oportunidades-autocomplete-clientes");

                let html = "";
                if (item.noResult) {
                    html = `<div class="bloco bloco-novo-cliente js-oportunidade-novo-cliente">
                        <span class="novo">Adicionar cliente "${input.value}"</span>
                        </div>`;
                    Eloca.load(html);
                } else {
                    let tipoBloco = "bloco-pf";
                    let nome = item.nome;
                    if (item.pj) {
                        tipoBloco = "bloco-pj";
                        nome = item.nome_fantasia;
                    }

                    html = `<div class="bloco ${tipoBloco}">
                    <span class="nome">${nome}</span>
                    <span class="small contato ${item.pj ? '' : 'd-none'}">Contato: ${item.nome}</span>
                    <span class="email">${item.email}</span>
                    <span class="telefone">${item.telefone1 ? item.telefone1 : ""
                        }</span>
                    </div>`;
                }
                return $("<li>").append(html).appendTo(ul);
            };
    });

    $(".js-cancelar-novo-cliente", context).on("click", function () {
        cancelNovoCliente();
    });

    $(".js-valida-oportunidade", context).on("click", function () {
        let valid = true;
        const configWhatsappAtivo = $(
            "#js-config-whatsapp-ativo",
            context
        ).val();
        const contextForm = $(this).closest(".js-form-oportunidade");
        if (!$("#nome", contextForm).val()) {
            $(" #nome", contextForm).addClass(
                "is-invalid"
            );
            valid = false;
        } else {
            $("#nome", contextForm).removeClass(
                "is-invalid"
            );
        }
        if (
            !$(".js-input-autocomplete", contextForm).val() &&
            !$(this).data("novoCliente")
        ) {
            $(".js-autocomplete-cliente", contextForm).addClass("is-invalid");
            valid = false;
        } else {
            $(".js-autocomplete-cliente", contextForm
            ).removeClass("is-invalid");
        }
        if ($(this).data("novoCliente")) {
            if (!$(" #cliente_nome", contextForm).val()) {
                $(" #cliente_nome", contextForm).addClass(
                    "is-invalid"
                );
                valid = false;
            } else {
                $("#cliente_nome", contextForm
                ).removeClass("is-invalid");
            }

            if (configWhatsappAtivo) {
                const telefone = $("#cliente_telefone", contextForm).val();
                const mascara = $("#cliente_telefone", contextForm).data('mascara');
                let telefoneInvalido = false;
                if (window.location.pathname != '/painel/inbox' && !telefone) {
                    valid = false;
                    telefoneInvalido = true;
                } else if (mascara == 'br' && (telefone.length < 14 || telefone.length > 15)) {
                    const soNumeros = telefone.replace(/\D/g, "");
                    if (!(soNumeros.startsWith("0800") && soNumeros.length === 11)) {
                        valid = false;
                        telefoneInvalido = true;
                    }
                } else if (mascara == 'py' && telefone.length != 10) {
                    valid = false;
                    telefoneInvalido = true;
                }
                if (telefoneInvalido) {
                    $("#cliente_telefone", contextForm).addClass("is-invalid");
                } else {
                    $("#cliente_telefone", contextForm).removeClass("is-invalid");
                }
            } else {
                const regex = /\S+@\S+\.\S+/;
                const email = $("#cliente_email", contextForm).val();
                if (!email || !regex.test(email)) {
                    $("#cliente_email", contextForm).addClass("is-invalid");
                    valid = false;
                } else {
                    $("#cliente_email", contextForm).removeClass("is-invalid");
                }
            }
        }

        if (valid) {
            $("#overlayer-loading").addClass("show-overlayer");
            $(this).closest('form').submit();
        }
    });

    $(".js-filtro-oportunidade", context).on("change", function () {


        if (
            $("select[name='status']").val() == 1 ||
            $("select[name='status']").val() == 3
        ) {
            $(".js-div-status-conteudo").remove();
        }

        if (
            $("select[name='tipo']").val() == ""
        ) {
            $(".js-div-tipo-conteudo").remove();
        }

        $("#overlayer-loading").addClass("show-overlayer");
        $(".js-form-filtro-oportunidades", context).submit();
    });

    $(".js-select-tipo-customizado", context).on("change", function () {
        if ($(this).val() != "todos") {
            $(".js-div-tipo-conteudo-customizado").removeClass("d-none");
        } else {
            $(".js-div-tipo-conteudo-customizado").addClass("d-none");
        }
    });

    $(".js-update-fase", context).on("click", function () {
        const link = this;
        $.ajax({
            url: siteUrl("/painel/oportunidades/update-fase"),
            type: "put",
            data: {
                id: $(link).data("oportunidade"),
                fase_id: $(link).data("fase"),
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                if (!res.error) {
                    $(".js-fase-nome", context).text($(link).text());
                    $(".js-fase-cor", context).css(
                        "background-color",
                        $(link).data("cor")
                    );
                    $(".js-updated-at", context).text(res.updated_at);
                    showToastSuccess(context);
                } else {
                    const nomes = (res.campos_pendentes || [])
                        .map(function (campo) {
                            return campo.nome;
                        })
                        .filter(Boolean);
                    let msg =
                        res.message ||
                        "Para avançar esta oportunidade é necessário preencher todos os campos obrigatórios desta etapa.";
                    if (nomes.length) {
                        msg += " Pendentes: " + nomes.join(", ");
                    }
                    showToastDanger(context, msg);
                    destacarCamposPendentesFase(
                        context,
                        res.campos_pendentes || []
                    );
                }
            },
        });
    });

    function destacarCamposPendentesFase(ctx, camposPendentes) {
        $(".js-campo-customizado-valor", ctx).removeClass("is-invalid");
        (camposPendentes || []).forEach(function (campo) {
            const campoId = campo.id || campo;
            $("#conteudo_valor_" + campoId, ctx).addClass("is-invalid");
            $(
                '.js-campo-customizado-valor[data-campo-id="' + campoId + '"]',
                ctx
            ).addClass("is-invalid");
        });
        if (camposPendentes && camposPendentes.length) {
            const abaCampos = $('a[href="#campos"]', ctx);
            if (abaCampos.length) {
                abaCampos.tab("show");
            }
        }
    }

    $(document)
        .off("change.campoFaseObrigatorio", ".js-campo-fase-obrigatorio")
        .on("change.campoFaseObrigatorio", ".js-campo-fase-obrigatorio", function () {
            $(this)
                .closest(".js-campo-fase-item")
                .toggleClass("is-active", $(this).is(":checked"));
        });

    $(document)
        .off("change.campoObrigatorioFaseClear", ".js-campo-customizado-valor")
        .on(
            "change.campoObrigatorioFaseClear",
            ".js-campo-customizado-valor",
            function () {
                const $campo = $(this);
                if ($campo.data("obrigatorio-fase") != 1) {
                    return;
                }
                if (String($campo.val() || "").trim() !== "") {
                    return;
                }
                showToastDanger(
                    context,
                    "Campos obrigatórios da fase não podem ser removidos, apenas editados."
                );
                $campo.addClass("is-invalid");
            }
        );


    $(".js-select-status", context).on("click", function () {
        const elemento = this;
        $(".js-status-cor-selected").css(
            "background-color",
            $(elemento).attr("data-cor")
        );
        $(".js-status-nome-selected").html($(elemento).attr("data-nome"));

        $(".status-op-bloco").addClass("d-none");
        $(".status-op").addClass("d-none");
        let statusSelected = $(elemento).attr("data-id");
        let tipoSelected = $(elemento).attr("data-tipo");

        $(".status-op-bloco-" + $(elemento).attr("data-tipo")).removeClass(
            "d-none"
        );

        const dataTipo = $(elemento).attr("data-tipo")
        if (dataTipo != 3 && dataTipo != 4) {
            $(".status-op-" + dataTipo).removeClass("d-none");
        }

        if (statusSelected != "undefined" && statusSelected != "") {
            $(".btn-encerrar").attr("data-status", statusSelected);
            $(".btn-encerrar").attr("data-tipo", tipoSelected);
            $(".btn-encerrar").attr(
                "data-atendimento",
                $(elemento).attr("data-atendimento")
            );
            $(".btn-encerrar").attr(
                "data-perda",
                $(elemento).attr("data-perda")
            );
        }
    });
    $(".js-select-status-tipo", context).on("change", function () {
        $(".status-op").addClass("d-none");
        let tipoSelected = $(".js-update-status").attr("data-tipo");
        let subTipoSelected = "";
        if (tipoSelected == 4) {
            const valor = $(this).find("option:selected").attr("data-tipo-atendimento");
            subTipoSelected = ".status-op-atendimento-" + valor;
            $(subTipoSelected).removeClass("d-none");
            $(".status-op-atendimento-todos").removeClass("d-none");
        } else if (tipoSelected == 3) {
            const valor = $(this).find("option:selected").attr("data-motivo_perda_id");
            subTipoSelected = ".status-op-perda-" + valor;
            $(subTipoSelected).removeClass("d-none");
            $(".status-op-perda-todos").removeClass("d-none");
        } else {
            $(".status-op-" + $(elemento).attr("data-tipo")).removeClass("d-none");
        }
    });
    $(".js-update-status", context).on("click", function () {
        const link = this;
        let dataOportunidade = $(link).attr("data-oportunidade");
        let dataStatus = $(link).attr("data-status");
        let dataTipo = $(link).attr("data-tipo");
        let tipoAtendimento = $("#select-tipo-atendimento").find('option:selected').attr('data-tipo-atendimento');
        let motivo_perda_id = $("#select-motivo-perda-id").find('option:selected').attr('data-motivo_perda_id');

        let atendimento = $(link).attr("data-atendimento");
        let perda = $(link).attr("data-perda");

        let conteudo_valor = document.querySelectorAll(".js-conteudo-valor");
        let camposCustomizados = [];
        if (conteudo_valor.length > 0) {
            for (let conteudo of conteudo_valor) {
                let tipos = conteudo.getAttribute("data-required");
                let subTiposAtendimento = conteudo.getAttribute("data-obrigatorio-atendimento");
                let subTiposPerda = conteudo.getAttribute("data-obrigatorio-perda");
                tipos = tipos.split(",");
                subTiposAtendimento = subTiposAtendimento.split(",");
                subTiposPerda = subTiposPerda.split(",");
                for (let tipo of tipos) {
                    if (dataTipo != 2 && dataTipo != 3 && dataTipo != 4) {//validando status da oportunidade diretamente e sozinho isolado tá errado,
                        //era pra validar o campos obrigatório vindo do campo customizado e não simplesmente o status da venda,
                        //pois até mesmo um status atendimento pode ser obrigatório se
                        //marcado na configuração do campo customizado como obrigatório
                        if (dataTipo == tipo && isEmpty(conteudo.value)) {
                            showToastDanger(
                                context,
                                "Por favor preencha todos os campos customizados obrigatórios 1"
                            );
                            return false;
                        }
                    } else if (dataTipo == 2 && dataTipo == tipo) {
                        if (dataTipo == tipo && isEmpty(conteudo.value)) {
                            showToastDanger(
                                context,
                                "Por favor preencha todos os campos customizados obrigatórios"
                            );
                            return false;
                        } else {
                            camposCustomizados.push({
                                id: conteudo.getAttribute("data-id"),
                                valor: conteudo.value,
                            });
                        }
                    } else if (dataTipo == 3 && dataTipo == tipo) {
                        let valorSelecionado = $("#select-motivo-perda-id").find("option:selected").attr("data-motivo_perda_id");
                        if (subTiposPerda.includes('todos') && isEmpty(conteudo.value)) {
                            showToastDanger(
                                context,
                                "Por favor preencha todos os campos customizados obrigatórios"
                            );
                            return false;
                        } else if (
                            subTiposPerda.includes(valorSelecionado) &&
                            isEmpty(conteudo.value)
                        ) {
                            showToastDanger(
                                context,
                                "Por favor preencha todos os campos customizados obrigatórios"
                            );
                            return false;
                        } else {
                            camposCustomizados.push({
                                id: conteudo.getAttribute("data-id"),
                                valor: conteudo.value,
                            });
                        }
                    } else if (dataTipo == 4 && dataTipo == tipo) {
                        let valorSelecionado = $("#select-tipo-atendimento").find("option:selected").attr("data-tipo-atendimento");
                        if (subTiposAtendimento.includes("todos") && isEmpty(conteudo.value)) {
                            showToastDanger(
                                context,
                                "Por favor preencha todos os campos customizados obrigatórios"
                            );
                            return false;
                        } else if (
                            subTiposAtendimento.includes(valorSelecionado) &&
                            isEmpty(conteudo.value)
                        ) {
                            showToastDanger(
                                context,
                                "Por favor preencha todos os campos customizados obrigatórios"
                            );
                            return false;
                        } else {
                            camposCustomizados.push({
                                id: conteudo.getAttribute("data-id"),
                                valor: conteudo.value,
                            });
                        }

                    } else {
                        camposCustomizados.push({
                            id: conteudo.getAttribute("data-id"),
                            valor: conteudo.value,
                        });
                    }
                }
            }
        }

        if (
            (
                parseInt(dataOportunidade) <= 0 ||
                parseInt(dataStatus) <= 0 ||
                isEmpty(dataStatus)
            ) || (atendimento && isEmpty(tipoAtendimento)) || (perda && isEmpty(motivo_perda_id))
        ) {
            showToastDanger(context, "Por favor preencha todos os dados");
            return false;
        } else {
            $("#overlayer-loading").addClass("show-overlayer");
            $.ajax({
                url: siteUrl("/painel/oportunidades/update-status"),
                type: "put",
                data: {
                    id: dataOportunidade,
                    status: dataStatus,
                    tipo_atendimento_id: tipoAtendimento,
                    motivo_perda_id: motivo_perda_id,
                    campos_customizados: camposCustomizados,
                },
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
                success: function (res) {
                    if (!res.error) {
                        showToastSuccess(context);
                        window.location.reload(true);
                    } else {
                        $("#overlayer-loading").removeClass("show-overlayer");
                        showToastDanger(context, res.message);
                    }
                },
            });
        }
    });

    $(context).on("click", ".js-reenviar-mensagem", function () {
        const input = $(this).closest(".mensagem__usuario");
        const mensagem_id = input.find(".messagem_id").val();

        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl(`/painel/chat/reenviar-msg`),
            type: "post",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                mensagem_id: mensagem_id,
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (!res.error) {
                    $(".msg-nao-enviada").remove();
                    showToastSuccess(context, "Mensagem reenviada com sucesso");
                } else {
                    showToastDanger(context, res.message);
                }
            },
            error: function (err) {
                console.log("err", err);
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context, "Ocorreu um erro inesperado");
            },
        });
    });

    $(".js-updated-title-oportunidade", context).on(
        "blur",
        ".input-title-editable",
        function () {
            const novoNome = $(this).val();
            const antigoNome = $(".antigo-nome-oportunidade").val();
            const idOportunidade = $(".id-oportunidade").val();

            if (novoNome !== antigoNome && novoNome !== "") {
                $("#overlayer-loading").addClass("show-overlayer");
                $.ajax({
                    url: siteUrl(
                        `/painel/oportunidades/update-nome/${idOportunidade}`
                    ),
                    type: "put",
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        ),
                    },
                    data: {
                        nome: novoNome,
                    },
                    success: function (res) {
                        $("#overlayer-loading").removeClass("show-overlayer");
                        $(".js-title-oportunidade").text(novoNome);
                        $(".antigo-nome-oportunidade").val(novoNome);
                    },
                    error: function (err) {
                        console.log("err", err);
                        $("#overlayer-loading").removeClass("show-overlayer");
                        $(".input-title-editable").val(antigoNome);
                        $(".js-title-oportunidade").text(antigoNome);
                    },
                });
            }

            if (novoNome === "") {
                location.reload();
            }
        }
    );

    $(".js-data-previsao-fechamento").on("focusin", function () {
        $(this).data("val", $(this).val());
    });

    $(".js-lead-aderente", context).on("focusin", function () {
        $(this).data("val", $(this).val());
    });

    $(".js-lead-aderente", context).on("change", function () {
        const $select = $(this);
        const prev = $select.data("val");

        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: $select.data("url"),
            type: "post",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                aderente: $select.val(),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (!res.error) {
                    $select.data("val", $select.val());
                    showToastSuccess(context, "Lead aderente atualizado.");
                    return;
                }
                $select.val(prev);
                showToastDanger(context, res.message);
            },
            error: function () {
                $("#overlayer-loading").removeClass("show-overlayer");
                $select.val(prev);
                showToastDanger(context, "Não foi possível salvar o lead aderente.");
            },
        });
    });

    $(".js-data-previsao-fechamento", context).on("change", function () {
        const data = $(this).val();
        const idOportunidade = $(".id-oportunidade").val();
        const prev = $(this).data("val");

        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl(
                `/painel/oportunidades/update-previsao-fechamento/${idOportunidade}`
            ),
            type: "put",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                    "content"
                ),
            },
            data: {
                data: data,
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (!res.error) {
                    showToastSuccess(context, "Previsão de fechamento atualizada com sucesso.");
                } else {
                    $(".js-data-previsao-fechamento").val(prev);
                    showToastDanger(context, res.message);
                }
            }
        });
    });

    $(".js-switch-tarefas", context).on("click", function () {
        if ($(this).hasClass("js-show-abertas")) {
            $(this).addClass("js-show-fechadas");
            $(this).removeClass("js-show-abertas");
            $(this).text("Ver abertas");
            const total = $(".js-tarefa-concluida", context).length;
            $(".js-total-tarefas", context).text(
                `Tarefas concluídas (${total})`
            );
        } else {
            $(this).addClass("js-show-abertas");
            $(this).removeClass("js-show-fechadas");
            $(this).text("Ver concluídas");
            const total = $(".js-tarefa-aberta", context).length;
            $(".js-total-tarefas", context).text(`Tarefas abertas (${total})`);
        }
        $(".js-tarefa", context).toggleClass("d-none");
    });

    $(".js-marcar-tarefa-concluida", context).on("click", function () {
        const $btn = $(this);
        const url = $btn.data("url");
        if (!url || $btn.prop("disabled")) {
            return;
        }
        const $tarefa = $btn.closest(".js-tarefa");
        $btn.prop("disabled", true);
        $.ajax({
            url,
            method: "PATCH",
            dataType: "json",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
            },
            success(res) {
                $tarefa
                    .removeClass("js-tarefa-aberta")
                    .addClass("js-tarefa-concluida d-none");
                $btn.remove();
                const total = $(".js-tarefa-aberta", context).length;
                $(".js-total-tarefas", context).text(
                    `Tarefas abertas (${total})`
                );
                showToastSuccess(
                    context,
                    (res && res.message) || "Tarefa marcada como concluída."
                );
                if (typeof window.elocaNotificarCarteiraKanbanAtualizar === "function") {
                    const clienteId = $btn.data("cliente-id");
                    window.elocaNotificarCarteiraKanbanAtualizar({
                        clienteId: clienteId,
                    });
                }
            },
            error(xhr) {
                const msg =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Não foi possível concluir a tarefa.";
                showToastDanger(context, msg);
            },
            complete() {
                if ($btn.closest("body").length) {
                    $btn.prop("disabled", false);
                }
            },
        });
    });

    window.onscroll = function () {
        if (
            document.body.scrollTop > 60 ||
            document.documentElement.scrollTop > 60
        ) {
            $(".js-bloco-chat").addClass("onscroll");
        } else {
            $(".js-bloco-chat").removeClass("onscroll");
        }
    };

    $(".js-seleciona-produto", context).on("click", function () {
        const contextChat = $(this).closest('.oportunidade-chat');
        const produto = $(".js-autocomplete-produto", contextChat).val();
        const preco = $(".js-preco-produto", contextChat).val();

        if (produto) {
            const texto = `${produto}${preco}`;
            $(".js-input-chat", contextChat).val(texto);
            $(".js-autocomplete-produto", contextChat).val("");
        }
    });

    $('body').on('click', ".js-imagem-chat", function () {
        $("#modalImagemChat img").attr("src", this.src);
        $(".fotoChatCliente").val(this.src);
        $("#modalImagemChat").modal();

        if ($(this).data("foto") === "cliente") {
            $(".btn-salvar-foto-cliente-oportunidade").show();
        } else {
            $(".btn-salvar-foto-cliente-oportunidade").hide();
        }
    });

    $(".js-autocomplete-produto-oportunidades", context).each(function () {
        const input = this;
        $(input)
            .autocomplete({
                source: siteUrl("/painel/produtos/busca/autocomplete?crm=true"),
                minLength: 2,
                select: function (event, ui) {
                    $("#overlayer-loading").addClass("show-overlayer");
                    $.ajax({
                        url: siteUrl("/painel/oportunidades/adicionar-produto"),
                        type: "post",
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                "content"
                            ),
                        },
                        data: {
                            produto_id: ui.item.id,
                            oportunidade_id: $(input).data("oportunidade-id"),
                        },

                        success: function (res) {
                            $("#overlayer-loading").removeClass(
                                "show-overlayer"
                            );

                            if (res.error) {
                                showToastDanger(context, res.message);
                            } else {
                                showToastSuccess(context);
                                
                                for (const item of res.html) {
                                    $(".js-tabela-produtos tbody", context).append(
                                        item.view
                                    );
                                    Eloca.load($(`#tr-item-${item.id}`));
                                    atualizarTotalTabela(`#tr-item-${item.id}`);
                                }
                                
                                if (typeof window.elocaSincronizarBotoesOrcamentoPorProdutos === "function") {
                                    window.elocaSincronizarBotoesOrcamentoPorProdutos();
                                } else if (

                                    $(".js-racerregar-modelo").hasClass(
                                        "d-none"
                                    )
                                ) {
                                    $(".js-racerregar-modelo").removeClass(
                                        "d-none"
                                    );
                                }
                            }
                        },
                        error: function (err) {
                            $("#overlayer-loading").removeClass(
                                "show-overlayer"
                            );
                            showToastDanger(context);
                        },
                    });
                },
            })
            .autocomplete("instance")._renderItem = function (ul, item) {
                const url = siteUrl(`/painel/pedidos/produtosEdit/add/${item.id}`);
                let sku = "";
                if (item.sku && item.sku != null) {
                    sku = ` - SKU: ${item.sku}`;
                }
                
                let servicoBadge = "";
                if (item.servico && item.servico == 1) {
                    servicoBadge = ' - Serviço';
                }

                return $("<li class='lista-produto'>")
                    .append(`#${item.id} - ${item.nome}${sku}${servicoBadge}`)
                    .appendTo(ul);
            };
    });

    $(".js-autocomplete-produto-oportunidades-ccl", context).each(function () {
        const input = this;
        $(input)
            .autocomplete({
                source: siteUrl("/painel/produtos/busca/autocomplete?crm=true"),
                minLength: 2,
                select: function (event, ui) {
                    $("#overlayer-loading").addClass("show-overlayer");
                    $.ajax({
                        url: siteUrl("/painel/oportunidades/ccl/produto"),
                        type: "post",
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                "content"
                            ),
                        },
                        data: {
                            produto_id: ui.item.id,
                            oportunidade_id: $(input).data("oportunidade-id"),
                        },

                        success: function (res) {
                            $("#overlayer-loading").removeClass(
                                "show-overlayer"
                            );

                            if (res.error) {
                                showToastDanger(context, res.message);
                            } else {
                                showToastSuccess(context);
                                for (const item of res.html) {
                                    $(".js-tabela-produtos tbody", context).append(
                                        item.view
                                    );
                                   Eloca.load($(`#tr-item-${item.id}`));
                                    atualizarTotalTabela(`#tr-item-${item.id}`);
                                }
                                atualizarDadosOportunidadeCCL(); //atualizarTotalTabelaCCL();


                                if (typeof window.elocaSincronizarBotoesOrcamentoPorProdutos === "function") {
                                    window.elocaSincronizarBotoesOrcamentoPorProdutos();
                                } else if ($('.js-racerregar-modelo').hasClass('d-none')) {
                                    $('.js-racerregar-modelo').removeClass('d-none');
                                }
                            }
                        },
                        error: function (err) {
                            $("#overlayer-loading").removeClass(
                                "show-overlayer"
                            );
                            showToastDanger(context);
                        },
                    });
                },
            })
            .autocomplete("instance")._renderItem = function (ul, item) {
                const url = siteUrl(`/painel/pedidos/produtosEdit/add/${item.id}`);
                let sku = "";
                if (item.sku && item.sku != null) {
                    sku = ` - SKU: ${item.sku}`;
                }
                
                let servicoBadge = "";
                if (item.servico && item.servico == 1) {
                    servicoBadge = " - Serviço";
                }

                return $("<li class='lista-produto'>")
                    .append(`#${item.id} - ${item.nome}${sku}${servicoBadge}`)
                    .appendTo(ul);
            };
    });

    function isQuantidadeExclusao(quantidade) {
        return quantidade !== "" && Number(quantidade) <= 0;
    }

    if (!window.__elocaConfirmExclusaoProdutoQuantidade) {
        window.__elocaConfirmExclusaoProdutoQuantidade = {
            confirmado: false,
            callbacks: {
                onConfirm: null,
                onCancel: null,
            },
        };
    }

    function confirmarExclusaoProdutoQuantidade(onConfirm, onCancel) {
        const state = window.__elocaConfirmExclusaoProdutoQuantidade;
        state.confirmado = false;
        state.callbacks = { onConfirm, onCancel };
        $("#modalConfirmaExcluirProdutoQuantidade").modal("show");
    }

    window.confirmarExclusaoProdutoQuantidade = confirmarExclusaoProdutoQuantidade;

    if (!window.__elocaConfirmExclusaoProdutoQuantidadeInit) {
        window.__elocaConfirmExclusaoProdutoQuantidadeInit = true;

        $("body").on(
            "click",
            "#modalConfirmaExcluirProdutoQuantidade .js-confirmar-exclusao-produto-quantidade",
            function () {
                const state = window.__elocaConfirmExclusaoProdutoQuantidade;
                state.confirmado = true;
                const onConfirm = state.callbacks.onConfirm;
                $("#modalConfirmaExcluirProdutoQuantidade").modal("hide");
                if (onConfirm) {
                    onConfirm();
                }
            }
        );

        $("body").on("hidden.bs.modal", "#modalConfirmaExcluirProdutoQuantidade", function () {
            const state = window.__elocaConfirmExclusaoProdutoQuantidade;
            if (!state.confirmado && state.callbacks.onCancel) {
                state.callbacks.onCancel();
            }

            state.callbacks = {
                onConfirm: null,
                onCancel: null,
            };
            state.confirmado = false;
        });
    }

    $(context).on(
        "focus",
        ".js-input-quantidade, .js-input-quantidade-ccl, #qdt-chat",
        function () {
            $(this).data("quantidade-anterior", $(this).val());
        }
    );

    function getPrecoFromFaixaSelect($select) {
        const faixaId = $select.val();
        if (isEmpty(faixaId)) {
            return null;
        }

        const $option = $select.find(`option[value="${faixaId}"]`);
        if (!$option.length) {
            return null;
        }

        return $option.data("preco");
    }

    function precoBaseDesconto(tr, precoFallback) {
        if ($("#js-calculo-preco-periodo").val() === "1") {
            const precoBruto = parseFloat(tr.attr("data-preco-bruto"));
            if (precoBruto > 0) {
                return precoBruto;
            }
        }

        let preco = $(".js-input-preco-tabela", tr).val();
        if (isEmpty(preco) || preco == "0,00") {
            preco = getPrecoFromFaixaSelect($(".js-select-faixa-produto", tr));
            if (isEmpty(preco) || preco == "0,00") {
                preco = precoFallback;
            }
        }

        return preco;
    }

    function getPrecoBrutoFromTrCcl(tr) {
        let precoBruto = $(".js-input-preco-tabela", tr).val();
        if (!isEmpty(precoBruto) && precoBruto !== "0,00") {
            return precoBruto;
        }

        precoBruto = getPrecoFromFaixaSelect($(".js-select-faixa-produto-ccl", tr));
        if (!isEmpty(precoBruto) && precoBruto !== "0,00") {
            return precoBruto;
        }

        precoBruto = $(".js-input-preco-ccl", tr).val();
        if (!isEmpty(precoBruto) && precoBruto !== "0,00") {
            return precoBruto;
        }

        return 0;
    }

    $(
        ".js-input-quantidade, .js-input-preco",
        context
    ).on("change", function () {
        const tr = $(this).closest(".js-tr-produtos");

        const controleDesconto = $("#controle_desconto").val();

        if (controleDesconto == 1) {
            let preco = precoBaseDesconto(tr, $(this).val());

            if (!isEmpty(preco)) {
                let descontoMaximo = $("#desconto_maximo").val();
                descontoMaximo = Number.parseFloat(descontoMaximo);
                preco = limpaMoeda(preco);
                let precoNovo = $(".js-input-preco", tr).val();
                precoNovo = limpaMoeda(precoNovo);

                let descRelativo = (precoNovo * 100) / preco;
                let porcentagem = 100 - descRelativo;


                const controleDesconto = $("#controle_desconto").val();

                if (controleDesconto == 1) {
                    
                    if (porcentagem > descontoMaximo) {
                        porcentagem = descontoMaximo;
                        let desc = (porcentagem * preco) / 100;
                        preco = preco - desc;
                        $(".js-input-preco", tr).val(
                            preco.toLocaleString("pt-br", {
                                minimumFractionDigits: 2,
                            })
                        );
                        $(".js-input-porcentagem", tr).val(descontoMaximo);
                        $("#modalAvisoDesconto").modal('show');
                    }
                }

                
            }
        }

        if ($(this).hasClass("js-input-quantidade")) {
            const quantidade = $(this).val();
            if (isQuantidadeExclusao(quantidade)) {
                const $input = $(this);
                const quantidadeAnterior = $input.data("quantidade-anterior") ?? 1;
                confirmarExclusaoProdutoQuantidade(
                    function () {
                        autalizarTotal(tr, 1);
                    },
                    function () {
                        $input.val(quantidadeAnterior);
                    }
                );
                return;
            }
        }

        autalizarTotal(tr, 1);
    });

    $(
        ".js-input-preco-bruto",
        context
    ).on("change", function () {
        const tr = $(this).closest(".js-tr-produtos");
        const preco = $(this).val();

        if ($("#js-calculo-preco-periodo").val() === "1") {
            const precoBase = limpaMoeda(preco);
            tr.attr("data-preco-bruto", precoBase);
            let porcentagem = limpaMoeda($(".js-input-porcentagem", tr).val() || "0");
            let precoNegociado = precoBase;
            if (porcentagem >= 100) {
                precoNegociado = 0;
            } else if (porcentagem > 0) {
                precoNegociado = precoBase - (porcentagem * precoBase) / 100;
            }
            $(".js-input-preco", tr).val(
                precoNegociado.toLocaleString("pt-br", {
                    minimumFractionDigits: 2,
                })
            );
            autalizarTotal(tr, 1);
            return;
        }

        $(".js-input-preco", tr).val(preco);
        $(".js-input-porcentagem", tr).val(0);
        $(".js-input-porcentagem", tr).trigger("change");
        autalizarTotal(tr, 1);
    });

    if (!window.__elocaBindDescontoPorcentagem) {
        window.__elocaBindDescontoPorcentagem = true;
        $('body').on(
            "change",
            ".js-input-porcentagem",
            function () {
                const tr = $(this).closest(".js-tr-produtos");
                let preco = precoBaseDesconto(tr, $(".js-input-preco", tr).val());
                if (!isEmpty(preco)) {

                    let porcentagem = $(this).val();
                    porcentagem = limpaMoeda(porcentagem);
                    const controleDesconto = $("#controle_desconto").val();

                    if (controleDesconto == 1) {

                        let descontoMaximo = $("#desconto_maximo").val();
                        descontoMaximo = Number.parseFloat(descontoMaximo);
                        if (porcentagem > descontoMaximo) {
                            porcentagem = descontoMaximo;
                            $(".js-input-porcentagem", tr).val(descontoMaximo);
                            $("#modalAvisoDesconto").modal('show');
                        }
                    }

                    if (porcentagem >= 100) {
                        preco = 0;
                    } else {
                        preco = limpaMoeda(preco);
                        let desc = (porcentagem * preco) / 100;
                        preco = preco - desc;
                    }

                    $(".js-input-preco", tr).val(
                        preco.toLocaleString("pt-br", {
                            minimumFractionDigits: 2,
                        })
                    );

                    $(".js-input-preco", tr).trigger("change");
                }
            }
        );
    }

    $(
        ".js-select-faixa-produto",
        context
    ).on("change", function () {
        const tr = $(this).closest(".js-tr-produtos");
        const preservarPrecoPeriodo = $("#js-calculo-preco-periodo").val() === "1"
            && $("input[name='data_inicio']").val()
            && $("input[name='data_fim']").val();
        if (!preservarPrecoPeriodo) {
            const precoFaixa = getPrecoFromFaixaSelect($(this));
            if (!isEmpty(precoFaixa) && precoFaixa !== "0,00") {
                const precoNumerico = limpaMoeda(precoFaixa);
                $(".js-input-preco", tr).val(
                    precoNumerico.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                    })
                );
                $(".js-input-porcentagem", tr).val(
                    (0).toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                    })
                );
            }
        }
        autalizarTotal(tr);
    });

    $('body').on('mouseover', ".js-chat-mensagem", function () {
        $(".js-dropdown-menu-chat").addClass('d-none');
        $(".js-dropdown-menu-chat", this).removeClass('d-none');
    });
    if ($(context).hasClass("js-chat-mensagem")) {
        $(context).on("mouseover", function () {
            $(".js-dropdown-menu-chat").addClass('d-none');
            $(".js-dropdown-menu-chat", this).removeClass('d-none');
        });
    }

    $('body').on('click', ".js-btn-encaminhar-msg", function () {
        let modal = $(".js-modal-encaminhar-msg");
        $("#js-chat-id", modal).val($(this).data('chat-id'));
        $("#encaminharMensagem").modal();
    });

    $('body').on('click', ".js-btn-responder-msg", function () {
        const chatId = $(this).data('chat-id');
        const msg = $(`#js-mensagem-${chatId}`).clone();
        $(".dropdown", msg).remove();
        $(".msg-nao-enviada", msg).remove();
        $(".js-status-message", msg).remove();
        $(".arrow", msg).remove();
        $(".mensagem__resposta", msg).remove();
        $(".js-aguardando-resposta", msg).remove();

        const msgHtml = msg.get(0).outerHTML;
        const contextChat = $(this).closest(".oportunidade-chat");

        $(".js-bloco-mensagem-resposta .js-conteudo-resposta", contextChat).html(`<div class="mensagens">${msgHtml}</div>`)
        $(".js-bloco-mensagem-resposta", contextChat).removeClass("d-none");

        $(".js-msg-resposta-id", contextChat).val(chatId);
        $(".js-input-chat", contextChat).focus();
    });

    $(".js-btn-cancelar-resposta", context).on("click", function () {
        const contextChat = $(this).closest(".oportunidade-chat");

        $(this).closest(".js-bloco-mensagem-resposta").addClass("d-none");
        $(".js-msg-resposta-id", contextChat).val("");
    })

    $('body').on("change",
        ".js-input-preco-ccl, .js-input-quantidade-ccl",
        function () {

            const tr = $(this).closest(".js-tr-produtos");
            const controleDesconto = $("#controle_desconto").val();
            if (controleDesconto == 1) {
                let preco = $(".js-input-preco-tabela", tr).val();
                
                if (isEmpty(preco) || (preco == '0,00')) {
                    preco = getPrecoFromFaixaSelect($(".js-select-faixa-produto-ccl", tr));
                    if (isEmpty(preco) || (preco == '0,00')) { 
                        preco = $(".js-input-preco-ccl", tr).val();
                    }
                }

                if (!isEmpty(preco)) {
                    preco = limpaMoeda(preco);
                    let precoNovo = $(".js-input-preco-ccl", tr).val();
                    precoNovo = limpaMoeda(precoNovo);

                    let descRelativo = (precoNovo * 100) / preco;
                    let porcentagem = 100 - descRelativo;

                    if (controleDesconto == 1) {
                        let descontoMaximo = $("#desconto_maximo").val();
                        descontoMaximo = Number.parseFloat(descontoMaximo);

                        if (porcentagem > descontoMaximo) {
                            porcentagem = descontoMaximo;
                            let desc = (porcentagem * preco) / 100;
                            preco = preco - desc;
                            $(".js-input-preco-ccl", tr).val(
                                preco.toLocaleString("pt-br", {
                                    minimumFractionDigits: 2,
                                })
                            );
                            $(".js-input-porcentagem-ccl", tr).val(descontoMaximo);
                            $("#modalAvisoDesconto").modal('show');
                        }
                    }
                }
            }

            if ($(this).hasClass("js-input-quantidade-ccl")) {
                const quantidade = $(this).val();
                if (isQuantidadeExclusao(quantidade)) {
                    const $input = $(this);
                    const quantidadeAnterior = $input.data("quantidade-anterior") ?? 1;
                    confirmarExclusaoProdutoQuantidade(
                        function () {
                            atualizarTotalCCL(tr, 1);
                        },
                        function () {
                            $input.val(quantidadeAnterior);
                        }
                    );
                    return;
                }
            }

            atualizarTotalCCL(tr, 1);
    });

    $('body').on("change",
        ".js-input-porcentagem-ccl",
        function () {
        const tr = $(this).closest(".js-tr-produtos");
        let preco = $(".js-input-preco-tabela", tr).val();
        if (isEmpty(preco) || (preco == '0,00')) {
            preco = getPrecoFromFaixaSelect($(".js-select-faixa-produto-ccl", tr));
            if (isEmpty(preco) || (preco == '0,00')) { 
                preco = $(".js-input-preco-ccl", tr).val();
            }
        }
        if (!isEmpty(preco)) {
            let porcentagem = $(this).val();
            porcentagem = limpaMoeda(porcentagem);
            const controleDesconto = $("#controle_desconto").val();

            if (controleDesconto == 1) {
                let descontoMaximo = $("#desconto_maximo").val();
                descontoMaximo = Number.parseFloat(descontoMaximo);
                if (porcentagem > descontoMaximo) {
                    porcentagem = descontoMaximo;
                    $(".js-input-porcentagem-ccl", tr).val(descontoMaximo);
                    $("#modalAvisoDesconto").modal('show')
                }
            }
        

            if (porcentagem >= 100) {
                preco = 0;
            } else {
                preco = limpaMoeda(preco);
                const desc = (porcentagem * preco) / 100;
                preco = preco - desc;
            }

            $(".js-input-preco-ccl", tr).val(
                preco.toLocaleString("pt-br", {
                    minimumFractionDigits: 2,
                })
            );
            $(".js-input-preco-ccl", tr).trigger("change");
        }
    });

    $(context).on("change",
        ".js-select-faixa-produto-ccl",
        function () {
            const tr = $(this).closest(".js-tr-produtos");
            const precoFaixa = getPrecoFromFaixaSelect($(this));

            if (!isEmpty(precoFaixa) && precoFaixa !== "0,00") {
                const precoNumerico = limpaMoeda(precoFaixa);
                $(".js-input-preco-ccl", tr).val(
                    precoNumerico.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                    })
                );
                $(".js-input-porcentagem-ccl", tr).val(
                    (0).toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                    })
                );
            }

            atualizarTotalCCL(tr);
    });

    function removerItensExcluidosOportunidade(deletedItemIds) {
        if (!deletedItemIds || !deletedItemIds.length) {
            return;
        }

        deletedItemIds.forEach(function (id) {
            $(`#tr-item-${id}`).remove();
            $(`#tr-item-chat-${id}`).remove();
        });
    }

    function autalizarTotal(tr, edicao = 0) {
        const item_id = $(".js-item-id", tr).val();
        let preco_bruto = $(".js-input-preco-bruto", tr).val();
        if (!preco_bruto) {
            preco_bruto = $(".js-input-preco-tabela", tr).val() ?? 0;
        }
        const faixa_id = $(".js-select-faixa-produto", tr).val();
        let preco = $(".js-input-preco", tr).val();
        const quantidade = $(".js-input-quantidade", tr).val();
        const porcentagem = $(".js-input-porcentagem", tr).val();
        const precoFaixaOption = getPrecoFromFaixaSelect($(".js-select-faixa-produto", tr));
        const porcentagemNumerica = limpaMoeda(porcentagem || "0");
        if (
            (isEmpty(preco) || preco === "0,00") &&
            porcentagemNumerica <= 0 &&
            !isEmpty(precoFaixaOption) &&
            precoFaixaOption !== "0,00"
        ) {
            preco = precoFaixaOption;
        }

        $.ajax({
            url: siteUrl("/painel/oportunidades/atualizar-produto"),
            type: "put",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: { item_id, faixa_id, preco, quantidade, edicao, porcentagem, preco_bruto },
            success: function (res) {

                $("#overlayer-loading").removeClass("show-overlayer");
                if (res.error) {
                    showToastDanger(context, res.message);
                } else {
                    showToastSuccess(context);
                    if (quantidade > 0) {
                        const novaTr = res.html;
                        $(tr, context).replaceWith(novaTr);
                        Eloca.load($(`#tr-item-${item_id}`));
                    } else {
                        removerItensExcluidosOportunidade(res.deleted_item_ids);
                        if (!res.deleted_item_ids || !res.deleted_item_ids.length) {
                            $(tr).remove();
                        }
                    }
                    atualizarTotalTabela(`#tr-item-${item_id}`);
                    atualizarTotalTabela(`tabela_produtos_principal`);
                    if (typeof window.elocaSincronizarBotoesOrcamentoPorProdutos === "function") {
                        window.elocaSincronizarBotoesOrcamentoPorProdutos();
                    }
                    if ($("#js-calculo-preco-periodo").val() === "1") {
                        atualizarDadosOportunidadeAtual(false);
                    }
                }
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context);
            },
        });
    }

    function atualizarTotalCCL(tr, edicao = 0) {
        const preco_bruto = getPrecoBrutoFromTrCcl(tr);
        const item_id = $(".js-item-id", tr).val();
        const faixa_id = $(".js-select-faixa-produto-ccl", tr).val();
        let preco = $(".js-input-preco-ccl", tr).val();
        const quantidade = $(".js-input-quantidade-ccl", tr).val();
        const porcentagem = $(".js-input-porcentagem-ccl", tr).val();
        const precoFaixaOption = getPrecoFromFaixaSelect($(".js-select-faixa-produto-ccl", tr));
        const porcentagemNumerica = limpaMoeda(porcentagem || "0");
        if (
            (isEmpty(preco) || preco === "0,00") &&
            porcentagemNumerica <= 0 &&
            !isEmpty(precoFaixaOption) &&
            precoFaixaOption !== "0,00"
        ) {
            preco = precoFaixaOption;
        }

        $.ajax({
            url: siteUrl("/painel/oportunidades/ccl/produto"),
            type: "put",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: { item_id, faixa_id, preco, quantidade, edicao, porcentagem, preco_bruto },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (res.error) {
                    showToastDanger(context, res.message);
                } else {
                    showToastSuccess(context);
                    if (quantidade > 0) {
                        const novaTr = res.html;
                        $(tr, context).replaceWith(novaTr);
                        //Eloca.load($(`#tr-item-${item_id}`));
                        $(".money").mask("000.000.000.000.000,00", { reverse: true });
                        atualizarTotalTabelaCCL();
                    } else {
                        removerItensExcluidosOportunidade(res.deleted_item_ids);
                        if (!res.deleted_item_ids || !res.deleted_item_ids.length) {
                            $(tr).remove();
                        }
                    }
                    atualizarDadosOportunidadeCCL();
                    if (typeof window.elocaSincronizarBotoesOrcamentoPorProdutos === "function") {
                        window.elocaSincronizarBotoesOrcamentoPorProdutos();
                    }
                }
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context);
            },
        });
    }

    function atualizarTotalTabela(id) {
        let total = 0;
        if (id == "tabela_produtos" || id == "tabela_produtos_principal") {
            id = `#${id}`;
            $(id)
                .find(".subtotalSpanProd")
                .each(function () {
                    let val = $(this).data("id");
                    val = limpaMoeda(val);
                    total += val;
                });
        } else {
            $(id).closest("table").find("tbody")
                .find(".subtotalSpanProd")
                .each(function () {
                    let val = $(this).data("id");
                    val = limpaMoeda(val);
                    total += val;
                });
        }

        total += parseFloat($(id)
                    .closest("table")
                    .find("tfoot")
                    .find(".js-valor-protecao-ccl")
                    .attr("data-valor") ?? 0);


        $(id)
            .closest("table")
            .find("#produtoOportunidadeSubtotalTotal")
            .html(
                total.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                }));
                
        total += limpaMoeda(
            $(id)
                .closest("table")
                .find("tfoot")
                .find("#deslocamento_entrega")
                .val());

        total += limpaMoeda(
            $(id)
                .closest("table")
                .find("tfoot")
                .find("#deslocamento_retirada")
                .val());
        $(id)
            .closest("table")
            .find("#produtoOportunidadeTotal")
            .html(
                total.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                })
            );

    }

    function atualizarTotalTabelaCCL() {
        let total = 0;
        let valorProtecao = 0;
        let totalDesconto = 0;
        let totalDescontoPercentual = 0;
        $(".subtotalSpanProdTbl").each( function () {
            const tr = $(this).closest(".js-tr-produtos");
            let quantidade = parseFloat($(this).data("quantidade"));
            if (isNaN(quantidade)) {
                const qtyInput = $(".js-input-quantidade-ccl", tr).val();
                quantidade = qtyInput ? parseFloat(qtyInput) : 1;
            }

            let val = $(this).data("id");
            val = limpaMoeda(val);
            total += val;

           const protecao = $(this).data("percentual-protecao") ?? 0;
           const desconto = $(this).data("desconto-valor") ?? 0;
           valorProtecao += (parseFloat(protecao) / 100) * val;
           totalDesconto += parseFloat(desconto) * quantidade;
        });


        let subtotalSemDesconto = total + totalDesconto;
        totalDescontoPercentual = (totalDesconto / subtotalSemDesconto) * 100;

        if ($("input[name='protecao']").length > 0 && !$("input[name='protecao']").prop('checked')) {
            valorProtecao = 0;
        }

        $("#produtoOportunidadeTotal").html(
            total.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            })
        );

        totalDescontoPercentual = !isNaN(totalDescontoPercentual) ? totalDescontoPercentual : 0;
        totalDesconto = !isNaN(totalDesconto) ? totalDesconto : 0;
        totalDescontoPercentual = totalDescontoPercentual.toLocaleString("pt-br", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        $("#produtoOportunidadeDescontoTotal").html(
            totalDesconto.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            }) + '<br/> ' + totalDescontoPercentual + ' %'
        );

        total += valorProtecao;
        let valorProtecaoProtecaoBRL = valorProtecao.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
        });

        $(".js-valor-protecao-ccl").html(valorProtecaoProtecaoBRL);
        $(".js-valor-protecao-ccl").data("valor", valorProtecao);

        let seletorValorEntrega = $("input[name='valor_deslocamento_entrega']");
        let seletorValorRetirada = $("input[name='valor_deslocamento_retirada']");

        if ($("input[name='entrega']").length > 0 && $("input[name='entrega']").prop('checked')) {

            $(".js-tr-deslocamento-entrega").show();
            total += (seletorValorEntrega.length > 0) ? limpaMoeda(seletorValorEntrega.val()) : 0;
        } else {

            $(".js-tr-deslocamento-entrega").hide();
            $("input[name='valor_deslocamento_entrega']").val("0");
        }

        total += (seletorValorRetirada.length > 0) ? limpaMoeda(seletorValorRetirada.val()) : 0;
        $(".js-total-produtos-oportunidade-ccl").html(
            total.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            })
        );
    }

    function atualizarDadosOportunidadeAtual(shouldReload) {
        let oportunidadeId = $("input[name='oportunidade_id']").val();
        let observacao = $("textarea[name='observacao']").val();
        let valorDeslocamentoEntrega = $("input[name='valor_deslocamento_entrega']").val();
        valorDeslocamentoEntrega = limpaMoeda(valorDeslocamentoEntrega);

        let valorDeslocamentoRetirada = $("input[name='valor_deslocamento_retirada']").val();
        valorDeslocamentoRetirada = limpaMoeda(valorDeslocamentoRetirada);
        let tipoPagamentoId = $("select[name='tipo_pagamento_id']").val();

        let dataInicio = $("input[name='data_inicio']").val();
        let dataFim = $("input[name='data_fim']").val();
        if (dataInicio && dataInicio.indexOf('/') > -1) {
            dataInicio = dataInicio.split('/').reverse().join('-');
        }
        if (dataFim && dataFim.indexOf('/') > -1) {
            dataFim = dataFim.split('/').reverse().join('-');
        }

        if ($("#js-calculo-preco-periodo").val() === "1") {
            const $dataFim = $("input[name='data_fim']");
            $dataFim.removeClass("is-invalid");
            $dataFim.siblings(".js-erro-data-fim").remove();
            if (dataInicio && dataFim && dataFim < dataInicio) {
                $dataFim.addClass("is-invalid");
                $dataFim.after(
                    '<div class="invalid-feedback js-erro-data-fim d-block">A data final não pode ser menor que a data inicial.</div>'
                );
                $dataFim.val("");
                return;
            }
        }

        atualizarDadosOportunidade(
            oportunidadeId,
            observacao,
            valorDeslocamentoEntrega,
            valorDeslocamentoRetirada,
            tipoPagamentoId,
            dataInicio,
            dataFim,
            shouldReload,
        );
    }

    $(".js-dados-oportunidade", context).on("change", function () {
        const nomeCampoAlterado = $(this).attr('name');
        const ehCampoData = nomeCampoAlterado === 'data_inicio' || nomeCampoAlterado === 'data_fim';
        const shouldReload = !ehCampoData;

        atualizarDadosOportunidadeAtual(shouldReload);
    });

    function aplicarPrecosPeriodo(itens) {
        if (!itens || !itens.length) {
            return;
        }

        for (const item of itens) {
            const tr = $(`#tr-item-${item.item_id}`);
            const precoBruto = item.preco_bruto != null ? item.preco_bruto : item.preco;
            const precoFmt = parseFloat(item.preco).toLocaleString("pt-br", {
                minimumFractionDigits: 2,
            });
            const precoBrutoFmt = parseFloat(precoBruto).toLocaleString("pt-br", {
                minimumFractionDigits: 2,
            });
            let quantidade = 1;

            if (tr.length) {
                tr.attr("data-preco-bruto", precoBruto);
                $(".js-input-preco-tabela", tr).val(precoBrutoFmt);
                $(".js-input-preco-bruto", tr).val(precoBrutoFmt);
                $(".js-input-preco", tr).val(precoFmt);
                const desconto = Number(item.desconto_percentual || 0);
                $(".js-input-porcentagem", tr).val(
                    desconto.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                    })
                );

                if (item.faixa_id && $(".js-select-faixa-produto", tr).length) {
                    $(".js-select-faixa-produto", tr).val(String(item.faixa_id));
                }

                quantidade = parseInt($(".js-input-quantidade", tr).val(), 10) || 1;
                const subtotal = parseFloat(item.preco) * quantidade;
                $(`.subtotalSpan-${item.item_id}`, tr)
                    .html("R$ " + subtotal.toFixed(2).replace(".", ","))
                    .attr("data-id", subtotal)
                    .data("id", subtotal);
            }

            const subtotalChat = parseFloat(item.preco) * quantidade;
            $(`[id="tr-item-chat-${item.item_id}"]`).each(function () {
                $(`.subtotalSpan-${item.item_id}`, this)
                    .html("R$ " + precoFmt)
                    .attr("data-id", subtotalChat)
                    .data("id", subtotalChat);
            });
        }

        if ($("#tabela_produtos_principal").length) {
            atualizarTotalTabela("tabela_produtos_principal");
        } else {
            atualizarTotalTabela("tabela_produtos");
        }

        $(".js-tabela-produtos-chat").each(function () {
            const tabela = $(this);
            let total = 0;
            tabela.find(".subtotalSpanProd").each(function () {
                total += limpaMoeda($(this).data("id"));
            });
            total += limpaMoeda(tabela.find("input[name='valor_deslocamento_entrega']").val());
            total += limpaMoeda(tabela.find("input[name='valor_deslocamento_retirada']").val());
            tabela.find("#produtoOportunidadeTotal").html(
                total.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                })
            );
        });
    }

    function atualizarDadosOportunidade(
        oportunidadeId,
        observacao,
        valorDeslocamentoEntrega,
        valorDeslocamentoRetirada,
        tipoPagamentoId,
        dataInicio,
        dataFim,
        shouldReload = true,
    ) {
        $.ajax({
            url: siteUrl(`/painel/oportunidades/dados`),
            type: "put",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                oportunidade_id: oportunidadeId,
                observacao: observacao,
                valor_deslocamento_entrega: valorDeslocamentoEntrega,
                valor_deslocamento_retirada: valorDeslocamentoRetirada,
                tipo_pagamento_id: tipoPagamentoId,
                data_inicio: dataInicio,
                data_fim: dataFim,
            },
            success: function (res) {
                const result = typeof res === "string" ? JSON.parse(res) : res;
                if (result.status == "erro") {
                    showToastDanger($("body"), result.mensagem);
                } else {
                    if (shouldReload) {
                        window.location.reload();
                    } else {
                        aplicarPrecosPeriodo(result.itens);
                        showToastSuccess($("body"), "Datas atualizadas com sucesso.");
                    }
                }
            },
            error: function (err) {
                showToastDanger(
                    context,
                    "Ocorreu um erro ao tentar incluir os produtos"
                );
            },
        });
    }

    function atualizarDadosOportunidadeCCL(reload = false) {
        let oportunidadeId = $("input[name='oportunidade_id']").val();
        let protecao = ($("input[name='protecao']").length > 0) ? $("input[name='protecao']").prop('checked') : null;
        let entrega = ($("input[name='entrega']").length > 0) ? $("input[name='entrega']").prop("checked") : null;
        let dataEntrega = $("input[name='data_entrega']").val();
        let observacao = $("textarea[name='observacao']").val();
        let clienteEnderecoId = $("select[name='cliente_endereco_id']").val();
        let tipoPagamentoId = $("select[name='tipo_pagamento_id']").val();

        let valorDeslocamentoEntrega = $("input[name='valor_deslocamento_entrega']").val();
        valorDeslocamentoEntrega = limpaMoeda(valorDeslocamentoEntrega);
        valorDeslocamentoEntrega = parseFloat(valorDeslocamentoEntrega);
        $("input[name='valor_deslocamento_entrega']").val(
            valorDeslocamentoEntrega.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
            })
        );

        let valorDeslocamentoRetirada = $("input[name='valor_deslocamento_retirada']").val();
        valorDeslocamentoRetirada = limpaMoeda(valorDeslocamentoRetirada);
        valorDeslocamentoRetirada = parseFloat(valorDeslocamentoRetirada);
        $("input[name='valor_deslocamento_retirada']").val(
            valorDeslocamentoRetirada.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
            })
        );


        if (!isEmpty(dataEntrega)) {

            dataEntrega = dataEntrega.split('/');
            dataEntrega = dataEntrega.reverse().join('-');
        }

        if (!entrega) {

            valorDeslocamentoEntrega = 0;
        }

        $.ajax({
            url: siteUrl(`/painel/oportunidades/ccl/dados`),
            type: "put",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                oportunidade_id: oportunidadeId,
                protecao: protecao,
                entrega: entrega,
                data_entrega: dataEntrega,
                valor_deslocamento_entrega: valorDeslocamentoEntrega,
                valor_deslocamento_retirada: valorDeslocamentoRetirada,
                observacao: observacao,
                cliente_endereco_id: clienteEnderecoId,
                tipo_pagamento_id: tipoPagamentoId,
            },
            success: function (res) {
                if (res.status == 'erro') {
                    showToastDanger($('body'), res.mensagem);
                }
                if (reload) {
                    window.location.reload();
                }
                atualizarTotalTabelaCCL();
            },
            error: function (err) {
                console.log("err", err);
            },
        });
    }

    $(document).ready(function () {
        if (parseInt(window.integracaoCcl) > 0) {

            if (
                $(`.js-tabela-produtos`,
                    document
                ).length &&
                $(`.js-dados-integracao-ccl-oportunidade`,
                    document
                ).length > 0
            ) {
                atualizarDadosOportunidadeCCL();
            }
        }
    });


    const divOportunidadesUsuario = $(".js-mostrar-oportunidades-usuario-ajax", context);
    const detalheOportunidade = $(".js-detalhe-oportunidade", context).length ? 1 : 0;
    const elementClickLoading = $(".js-click-to-loading", context);

    function carregarOportunidade(start, limit) {
        $(".js-container-oportunidades-loading").removeClass("d-none");
        elementClickLoading.data("loading", 1);
        $.ajax({
            url: siteUrl(`/painel/oportunidades/oportunidades-usuario-ajax`),
            type: "get",
            data: (function () {
                const d = {
                    detalhe_oportunidade: detalheOportunidade,
                    start: start,
                    limit: limit,
                };
                if (window.location.search.indexOf("kanban_modal") !== -1) {
                    d.kanban_modal = 1;
                }
                return d;
            })(),
            success: function (res) {
                elementClickLoading.data("start", start + limit);

                if (res.success == true) {
                    if (res.html.length > 0) {
                        elementClickLoading.data("loading", 0);
                    }

                    divOportunidadesUsuario
                        .find(".js-container-oportunidades")
                        .append(res.html.join("\n"));

                    const pathAtualSidebar = window.location.pathname;
                    $(
                        "#minhas-oportunidades .fase .conteudo li.oportunidade a"
                    ).each(function () {
                        try {
                            const p = new URL(this.href, window.location.origin)
                                .pathname;
                            if (p === pathAtualSidebar) {
                                $(this).parent().addClass("oportunidade-aberta");
                            }
                        } catch (err) {
                            /* ignore */
                        }
                    });

                    let oportunidades = divOportunidadesUsuario.find(
                        ".js-container-oportunidades li.oportunidade"
                    );
                    let total = oportunidades.length;
                    let valorTotal = 0;
                    oportunidades.each(function (index, element) {
                        let valor = $(element).find(".price-value").data("valor");
                        valor = parseFloat(valor);
                        if(!isNaN(valor)) {
                            valorTotal += valor;
                        }
                    });

                    $(".js-quantidade-oportunidades-fase")
                        .text(total + " oportunidades")
                        .attr("data-count-fase", String(total));
                    $(".js-total-oportunidades-fase").text("R$ "+ valorTotal.toLocaleString("pt-br", {minimumFractionDigits: 2}));

                    somaOportunidades();
                    ordenaOportunidades();
                }
                $(".js-container-oportunidades-loading").addClass("d-none");
            },
            error: function (error) {
                console.log(error);
                elementClickLoading.data("loading", 0);
                divOportunidadesUsuario.append(
                    "<p>Erro ao carregar oportunidades.</p>"
                );
                $(".js-container-oportunidades-loading").addClass("d-none");
            },
        });
    }

    if (divOportunidadesUsuario.length) {
        let start = parseInt(elementClickLoading.data("start"));
        let limit = parseInt(elementClickLoading.data("limit"));
        carregarOportunidade(start, limit);
    }

    $(".js-sidenav").on("scroll", function () {
        let element = $(this);
        let scrollHeight = element.prop("scrollHeight");
        let scrollTop = element.prop("scrollTop");
        let innerHeight = element.innerHeight();

        if (scrollTop + innerHeight >= scrollHeight - 15) {
            let elementClick = $(".js-click-to-loading", context);
            let isLoading = parseInt(elementClick.data("loading"));
            let start = parseInt(elementClick.data("start"));
            let limit = parseInt(elementClick.data("limit"));

            if (isLoading == 1) {
                return;
            }

            carregarOportunidade(start, limit);
        }
    });

    $(".js-click-to-loading", context).on("click", function (e) {
        e.preventDefault();
        let isLoading = parseInt($(this).data("loading"));
        let start = parseInt($(this).data("start"));
        let limit = parseInt($(this).data("limit"));

        if (isLoading == 1) {
            return;
        }

        carregarOportunidade(start, limit);
    });

    $(".js-dados-integracao-ccl-oportunidade", context).on("change", function () {
        atualizarDadosOportunidadeCCL();
    });

    $(".js-enviar-ccl", context).on("click", function () {
        $("#overlayer-loading").addClass("show-overlayer");
        let oportunidadeId = $("input[name='oportunidade_id']").val();
        $("#modalConfirmaEnvioCotacaoCCL").modal('hide');
        $.ajax({
            url: siteUrl(`/painel/oportunidades/ccl/dados`),
            type: "post",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                oportunidade_id: oportunidadeId,
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (res.status) {
                    if (item.status == "erro") {
                        showToastDanger(context, item.mensagem);
                    } else {
                        showToastSuccess(context, item.mensagem);
                    }

                    setTimeout(function () {
                        window.location.reload();
                    }, 3000);
                }
                else {
                    const len = res.length;
                    for (let i = 0; i < res.length; i++) {
                        item = res[i];
                        setTimeout(function () {
                            if (item.status == "erro") {
                                showToastDanger(context, item.mensagem);
                            } else {
                                showToastSuccess(context, item.mensagem);
                            }
                            if (i === len - 1) {
                                setTimeout(function () {
                                    window.location.reload();
                                }, 3000);
                            }
                        }, 2000 * i);
                    }
                }
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(
                    context,
                    err.responseJSON?.mensagem ??
                    "Não foi possivel atualizar a oportunidade."
                );
            },
        });
    });

    $(".js-atendente-oportunidade", context).on("change", function () {
        $("#overlayer-loading").addClass("show-overlayer");
        $(".js-pipeline-oportunidade option", context).remove();
        let id = this.value;
        if (!this.value) {
            id = 0
        }
        $.ajax({
            url: siteUrl(
                `/painel/oportunidades/pipelines-atendente/${id}`
            ),
            type: "get",
            success: function (res) {
                $(res).each(function (i, item) {
                    const selected = item.padrao ? 'SELECTED' : '';
                    $(".js-pipeline-oportunidade", context).append(
                        `<option value="${item.id}" ${selected}>${item.value}</option>`
                    );
                });
                $("#overlayer-loading").removeClass("show-overlayer");
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context);
            },
        });
    });

    function getLocacao(clienteId) {
        if (clienteId == undefined) {
            $(".js-input-locacao option", context).remove();
            $(".js-bloco-locacao", context).addClass("d-none");
            return;
        }
        $.ajax({
            url: siteUrl("/painel/clientes/busca/locacoes/" + clienteId),
            type: "get",
            xhrFields: {
                withCredentials: true
            },
            success: function (res) {
                $(".js-input-locacao option", context).remove();
                if (res.length > 1) {
                    $(".js-bloco-locacao", context).removeClass("d-none");
                    res.forEach(function (item) {
                        $(".js-input-locacao", context).append(
                            `<option value="${item.id}">${item.value}</option>`
                        );
                    });
                } else {
                    $(".js-bloco-locacao", context).addClass("d-none");
                }
            },
        });
    }

    function setNovoCliente(nome) {
        $(".js-valida-oportunidade", context).data("novoCliente", true);
        $(".js-bloco-autocomplete", context).addClass("d-none");
        $(".js-bloco-novo-cliente", context).removeClass("d-none");
        $(".js-bloco-novo-cliente #cliente_nome", context).val(nome);
    }

    function cancelNovoCliente() {
        $(".js-valida-oportunidade", context).data("novoCliente", false);
        $(".js-bloco-autocomplete", context).removeClass("d-none");
        $(".js-bloco-novo-cliente", context).addClass("d-none");
        $(".js-bloco-novo-cliente #cliente_nome", context).val("");
    }

    function somaOportunidades() {
        if ($("#kanban").attr("data-kanban-v2")) {
            return;
        }
        const alturaMinimaBloco = 34;
        const totalOportunidades = $(".js-fase .lista-oportunidades li").length;
        const totalFases = $(".js-fase", context).length;
        const alturaTotal = totalFases * 50 - totalFases * alturaMinimaBloco;
        $(".js-fase", context).each(function () {
            const fase = this;
            const faseId = $(this).data("id");
            let quantidade = 0;
            let total = 0.0;
            let alturaBloco = alturaMinimaBloco;
            let totalConversasNaoLidas = 0;
            $(".lista-oportunidades li", fase).each(function () {
                quantidade++;
                total += parseFloat($(this).data("valor"));
                if (
                    $(this).hasClass(
                        "js-mensagem-nao-lida"
                    )
                ) {
                    totalConversasNaoLidas++;
                }
            });
            const $qty = $(".js-quantidade-oportunidades-fase", fase);
            $qty.text(`${quantidade} oportunidades`);
            $qty.attr("data-count-fase", String(quantidade));
            if (totalConversasNaoLidas > 0) {
                $(".js-total-mensagens-fase", fase).html(
                    `<span class="mensagem-nao-lida">${totalConversasNaoLidas}</span>`
                );
            }

            $(".js-total-oportunidades-fase", fase).text(
                numeral(total).format("$ 0,0.00")
            );

            if (quantidade > 0) {
                alturaBloco += (quantidade * alturaTotal) / totalOportunidades;
            }

            $(`#funil-fase-${faseId} .js-quant-fases-funil`).html(quantidade);
            $(`#funil-fase-${faseId} .js-valor-fases-funil`).html(
                numeral(total).format("$ 0,0.00")
            );
            $(`#funil-fase-${faseId} .funil`).css(
                "height",
                `${alturaBloco.toFixed(2)}px`
            );
        });
    }

    function ordenaOportunidades() {
        if (
            $("#kanban", context).data("kanban-v2") &&
            typeof window.fluxoKanbanV2OrdenaOportunidades === "function"
        ) {
            window.fluxoKanbanV2OrdenaOportunidades(context);
            return;
        }
        $(".js-fase", context).each(function () {
            const fase = this;
            const itens = $(".lista-oportunidades li", fase);
            let itensOrdem = [];
            $(itens).each(function (index, li) {
                if ($(li).data("hora")) {
                    itensOrdem[index] = {
                        dataHora: $(li).data("hora"),
                        li: li,
                    };
                }
            });
            itensOrdem.sort((a, b) => {
                if (a.dataHora > b.dataHora) {
                    return 1;
                }
                if (a.dataHora < b.dataHora) {
                    return -1;
                }
                return 0;
            });
            itensOrdem.forEach(function (item) {
                $(".lista-oportunidades", fase).prepend(item.li);
            });
        });
    }

    $(".js-seleciona-msg-final-protocolo", context).on("click", function () {
        if ($(this).is(":checked")) {
            $(".js-msg-final-protocolo").removeClass("d-none");
            $(".js-input-msg-final-protocolo").attr("required", "required");
        } else {
            $(".js-msg-final-protocolo").addClass("d-none");
            $(".js-input-msg-final-protocolo").removeAttr("required");
        }
    });

    $(".js-seleciona-pipe-line-oportunidade", context).on("click", function () {
        if ($(this).is(":checked")) {
            $(".js-pipe-line-oportunidade").removeClass("d-none");
            $(".js-input-pipe-line-oportunidade-fase").attr(
                "required",
                "required"
            );
        } else {
            $(".js-pipe-line-oportunidade").addClass("d-none");
            $(".js-input-pipe-line-oportunidade-fase").removeAttr("required");
        }
    });

    $(".js-seleciona-envio-contrato-whatsapp", context).on("click", function () {
        if ($(this).is(":checked")) {
            $(".js-envio-contrato-whatsapp").removeClass("d-none");
            $(".js-input-envio-contrato-whatsapp").attr("required", "required");
        } else {
            $(".js-envio-contrato-whatsapp").addClass("d-none");
            $(".js-input-envio-contrato-whatsapp").removeAttr("required");
        }
    });

    $(".js-informar-tempo-sem-atendimento", context).on("click", function () {
        if ($(this).is(":checked")) {
            $(".js-tempo-sem-atendimento").removeClass("d-none");
            $(".js-input-tempo-sem-atendimento").attr("required", "required");
        } else {
            $(".js-tempo-sem-atendimento").addClass("d-none");
            $(".js-input-tempo-sem-atendimento").removeAttr("required");
        }
    });

    $(".js-informar-dias-encerramento-automatico", context).on("click", function () {
        if ($(this).is(":checked")) {
            $(".js-dias-encerramento-automatico").removeClass("d-none");
            $(".js-input-dias-encerramento-automatico").attr("required", "required");
            $(".js-input-status-encerramento-automatico").attr("required", "required");
            syncTipoEncerramentoAutomatico();
        } else {
            $(".js-dias-encerramento-automatico").addClass("d-none");
            $(".js-input-dias-encerramento-automatico").removeAttr("required");
            $(".js-input-status-encerramento-automatico").removeAttr("required");
            $(".js-select-motivo-perda-encerramento").removeAttr("required");
            $(".js-select-tipo-atendimento-encerramento").removeAttr("required");
        }
    });

    $(".js-tipo-encerramento-automatico", context).on("change", function () {
        syncTipoEncerramentoAutomatico();
    });

    function syncTipoEncerramentoAutomatico() {
        const $status = $(".js-tipo-encerramento-automatico", context);
        if (!$status.length) {
            return;
        }
        const tipo = String($status.find(":selected").attr("data-id") || "").trim();
        const $motivo = $(".js-opcoes-motivo-perda-encerramento", context);
        const $atendimento = $(".js-opcoes-tipo-atendimento-encerramento", context);
        const $selectMotivo = $(".js-select-motivo-perda-encerramento", context);
        const $selectAtendimento = $(".js-select-tipo-atendimento-encerramento", context);
        const checked = $(".js-informar-dias-encerramento-automatico", context).is(":checked");

        $motivo.addClass("d-none");
        $atendimento.addClass("d-none");
        $selectMotivo.prop("disabled", true).removeAttr("required");
        $selectAtendimento.prop("disabled", true).removeAttr("required");

        if (tipo === "3") {
            $motivo.removeClass("d-none");
            $selectMotivo.prop("disabled", false);
            if (checked) {
                $selectMotivo.attr("required", "required");
            }
            return;
        }

        if (tipo === "4") {
            $atendimento.removeClass("d-none");
            $selectAtendimento.prop("disabled", false);
            if (checked) {
                $selectAtendimento.attr("required", "required");
            }
        }
    }

    $(".js-seleciona-carrinho-pipe-line-oportunidade", context).on(
        "click",
        function () {
            if ($(this).is(":checked")) {
                $(".js-carrinho-pipe-line-oportunidade").removeClass("d-none");
                $(".js-carrinho-input-pipe-line-oportunidade-fase").attr(
                    "required",
                    "required"
                );
            } else {
                $(".js-carrinho-pipe-line-oportunidade").addClass("d-none");
                $(".js-carrinho-input-pipe-line-oportunidade-fase").removeAttr(
                    "required"
                );
            }
        }
    );

    $(".js-seleciona-contato-pipe-line-oportunidade", context).on(
        "click",
        function () {
            if ($(this).is(":checked")) {
                $(".js-contato-pipe-line-oportunidade").removeClass("d-none");
                $(".js-contato-input-pipe-line-oportunidade-fase").attr(
                    "required",
                    "required"
                );
            } else {
                $(".js-contato-pipe-line-oportunidade").addClass("d-none");
                $(".js-contato-input-pipe-line-oportunidade-fase").removeAttr(
                    "required"
                );
            }
        }
    );

    $(".js-seleciona-msg-saudacao", context).on("click", function () {
        if ($(this).is(":checked")) {
            $(".js-msg-saudacao").removeClass("d-none");
            $(".js-input-msg-saudacao").attr("required", "required");
        } else {
            $(".js-msg-saudacao").addClass("d-none");
            $(".js-input-msg-saudacao").removeAttr("required");
        }
    });

    $(".js-aprovacao-oportunidade", context).on("click", function () {
        if ($(this).is(":checked")) {
            $(".js-aprovacao-oportunidade-input").removeClass("d-none");
        } else {
            $(".js-aprovacao-oportunidade-input").addClass("d-none");
        }
    });

    $(".js-input-pipe-line-oportunidade", context).on("change", function () {
        let id = $(this).find(":selected").val();
        buscarFasePipelines(id, ".js-input-pipe-line-oportunidade-fase");
        buscarTiposAtendimentoPorPipeline(id, "#select-tipo-atendimento");
    });

    $(document).on("change", ".js-form-filtro-oportunidades input[name='pipeline_id']", function () {
        const valor = $(this).val() || "";
        const pipelines = valor.split(",").filter(function (id) {
            return id && id !== "pipeline-todos";
        });
        const pipelineId = pipelines.length === 1 ? pipelines[0] : "";
        buscarTiposAtendimentoPorPipeline(
            pipelineId,
            ".js-form-filtro-oportunidades select[name='tipo_atendimento_id']"
        );
    });

    $(".js-carrinho-input-pipe-line-oportunidade", context).on(
        "change", function () {
            let id = $(this).find(":selected").val();
            buscarFasePipelines(
                id,
                ".js-carrinho-input-pipe-line-oportunidade-fase"
            );
        }
    );

    $(".js-contato-input-pipe-line-oportunidade", context).on(
        "change",
        function () {
            let id = $(this).find(":selected").val();
            buscarFasePipelines(
                id,
                ".js-contato-input-pipe-line-oportunidade-fase"
            );

        }
    );

    $(".js-input-oportunidade-api", context).on(
        "change",
        function () {
            let id = $(this).find(":selected").val();
            buscarFasePipelines(
                id,
                ".js-input-oportunidade-fase-api"
            );

        }
    );

    

    $(context).on("click", ".js-salvar-contato", function () {
        const id = $(this).attr("data-id");
        if ($(`#salvarClientLoading${id}`).hasClass("d-none")) {
            $(`#salvarClientLoading${id}`).removeClass("d-none");
        }
        if (!$(`#btnSalvarCliente${id}`).hasClass("d-none")) {
            $(`#btnSalvarCliente${id}`).addClass("d-none");
        }

        let dados = $(`#cliente_contato${id}`, context).html();
        dados = dados.trim().split("<br>");
        const nome = dados[0].replace("<br>", "").replace("\n", "") ?? "";
        const telefone = dados[1]
            .replace("<br>", "")
            .replace("\n", "")
            .replace("+", "")
            .trim();
        $.ajax({
            url: siteUrl(`/painel/clientes/buscar/${telefone}/${nome}`),
            type: "get",
            statusCode: {
                204: function () {
                    $.ajax({
                        url: siteUrl(`/painel/clientes/criar-via-chat`),
                        type: "post",
                        data: {
                            nome: nome,
                            telefone1: telefone,
                        },
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                "content"
                            ),
                        },
                        success: function (res) {
                            if (
                                !$(`#salvarClientLoading${id}`).hasClass(
                                    "d-none"
                                )
                            ) {
                                $(`#salvarClientLoading${id}`).addClass(
                                    "d-none"
                                );
                            }
                            if (
                                $(`#btnSalvarCliente${id}`).hasClass("d-none")
                            ) {
                                $(`#btnSalvarCliente${id}`).removeClass(
                                    "d-none"
                                );
                            }
                            const contextChat =
                                $(this).closest(".oportunidade-chat");
                            showToastSuccess(context, res.message);
                            $(
                                ".js-criar-oportunidade-chat",
                                contextChat
                            ).click();
                            $("#cliente", contextChat).val(res.cliente.nome);
                            $("#fase_id", contextChat)
                                .val(
                                    $(
                                        "#fase_id option:first",
                                        contextChat
                                    ).val()
                                )
                                .change();
                            $('input[name="cliente_id"]', contextChat).val(
                                res.cliente.id
                            );
                        },
                        error: function (err) {
                            if (
                                !$(`#salvarClientLoading${id}`).hasClass(
                                    "d-none"
                                )
                            ) {
                                $(`#salvarClientLoading${id}`).addClass(
                                    "d-none"
                                );
                            }
                            if (
                                $(`#btnSalvarCliente${id}`).hasClass("d-none")
                            ) {
                                $(`#btnSalvarCliente${id}`).removeClass(
                                    "d-none"
                                );
                            }
                            showToastDanger(context, err.message);
                        },
                    });
                },
                200: function () {
                    if (!$(`#salvarClientLoading${id}`).hasClass("d-none")) {
                        $(`#salvarClientLoading${id}`).addClass("d-none");
                    }
                    if ($(`#btnSalvarCliente${id}`).hasClass("d-none")) {
                        $(`#btnSalvarCliente${id}`).removeClass("d-none");
                    }
                    $(".js-criar-oportunidade-chat").click();
                },
            },
            success: function (res) {
                if (res && typeof res.cliente != "undefined") {
                    setTimeout(() => {
                        $("#fase_id")
                            .val($("#fase_id option:first").val())
                            .change();
                        $("#cliente").val(res.cliente.nome);
                        $('input[name="cliente_id"]').val(res.cliente.id);
                        const nomeOportunidade =
                            res.cliente.nome.split(" ")[0] +
                            " - " +
                            res.cliente.telefone1;
                        $('input[name="nome"]').val(nomeOportunidade);
                    }, 700);
                }
            },
            error: function (err) {
                $("#novoClienteModalfechar").click();
                showToastDanger(context, err.message);
            },
        });
    });

    $(".js-autocomplete-produto-relatorio-oportunidades", context).each(function () {
        const input = this;
        $(input)
            .autocomplete({
                source: siteUrl("/painel/produtos/busca/autocomplete"),
                minLength: 2,
                select: function (event, ui) {
                    setTimeout(function () {
                        $(input)
                            .closest(".form-group")
                            .find(".js-input-autocomplete")
                            .val(ui.item.id);
                        $(input).val(ui.item.nome);
                        $(".js-form-filtro-oportunidades", context).submit();
                    }, 1);
                    Eloca.load($(`#tr-item-${item_id}`));
                },
            })
            .autocomplete("instance")._renderItem = function (ul, item) {
                let sku = "";
                if (item.sku && item.sku != null) {
                    sku = ` - SKU: ${item.sku}`;
                }

                return $("<li class='lista-produto'>")
                    .append(`#${item.id} - ${item.nome}${sku}`)
                    .appendTo(ul);
            };
    });

    $("#produto-autocomplete", context).on('change', function () {
        if ($(this).val() == '') {
            $(this)
                .closest(".form-group")
                .find(".js-input-autocomplete")
                .val('');
            $(".js-form-filtro-oportunidades", context).submit();
        }
    });

    $(".js-janela-midia", context).on("click", function () {
        const janelaId = $(this).data("id");
        const div = $(this).closest(".oportunidade-chat");
        const chat = $(".js-bloco-chat", div);
        const janela = $(janelaId).find(".js-body-modal-ajax");
        $(janela).html(`
            <div class="mt-5 mb-4 pb-1">
                <div class="loading-circle"><div></div><div></div><div></div><div></div></div>
            </div>
        `);
        $(div).toggleClass("row");
        $(chat).toggleClass("col-9");
        $(janelaId).toggleClass("d-none");

        if (!$(janelaId).hasClass("d-none")) {
            const url = $(this).data("url");
            $.ajax({
                url: url,
                type: "get",
                success: function (res) {
                    $(janela).html(res);
                    Eloca.load($(janela));
                },
            });
        }
    });

    $(".js-janela-mensagens", context).on("click", function () {
        const janelaId = $(this).data("id");
        const div = $(this).closest(".oportunidade-chat");
        const chat = $(".js-bloco-chat", div);
        $(div).toggleClass("row");
        $(chat).toggleClass("col-9");
        $(janelaId).toggleClass("d-none");
    });

    function pesquisarMensagens(input) {
        const janelaId = $(input).data("id");
        const clienteId = $(input).data("cliente-id");
        const janela = $(".js-body-modal-ajax"+janelaId);
        let inputPesquisar = $("input[name='pesquisar_mensagens"+janelaId+"']").val();
        if (inputPesquisar.length < 3) {
            $(janela).html("");
            Eloca.load($(janela));
            return;
        }

        $(janela).html(`
            <div class="mt-5 mb-4 pb-1">
                <div class="loading-circle"><div></div><div></div><div></div><div></div></div>
            </div>
        `);

        if (!$(janelaId).hasClass("d-none")) {
            $.ajax({
                url: siteUrl("/painel/oportunidades/pesquisar-mensagens/"+clienteId+"/"+janelaId+"/"+inputPesquisar),
                type: "get",
                success: function (res) {
                    $(janela).html(res);
                    Eloca.load($(janela));
                },
            });
        }
    }

    const pesquisarMensagensDelayed = functions.debounce(function () {
        const newContext = $(
                $(".js-aba-chat.active", context).data("tab"),
                context
            );
        const input = $(".js-pesquisar-mensagens", newContext);
        pesquisarMensagens(input); // aqui sempre pega o valor atualizado
    }, 500);
    $(".js-pesquisar-mensagens", context).on("keyup", function () {
         pesquisarMensagensDelayed();
    });

    $(".js-racerregar-modelo", context).on("click", function () {
        let camposCustomizados = document.querySelectorAll(".js-campo-customizado-valor");
        let configBloqueio = $("#block_orcamento_campos_customizados").val();
        if (camposCustomizados.length > 0) {
            for (let campo of camposCustomizados) {
                const obrigaImp = campo.getAttribute("data-impressao");
                const obriga = campo.getAttribute("data-obrigatorio");
                if (
                    (obrigaImp == 1 && isEmpty(campo.value)) ||
                    (configBloqueio == 1 && isEmpty(campo.value) && obriga > 0)
                ) {
                    showToastDanger(
                        context,
                        "Favor preencha os campos customizados obrigatorios."
                    );
                    $("#campos-tab").trigger("click");
                    $("#js-fechar-modal-imprimir").trigger("click");
                    return false;
                }
            }
        }

        const id = "#modalImprimirOportunidadeConteudo";
        $(id).html(`
            <div class="mt-5 mb-4 pb-1">
                <div class="loading-circle"><div></div><div></div><div></div><div></div></div>
            </div>
        `);
        const url = $(this).data("url");
        let retorno = null
        $.ajax({
            url: url,
            type: "get",
            success: function (res) {
                retorno = res;
                if (retorno.url) {
                    $.ajax({
                        url: retorno.url,
                        type: "get",
                        success: function (res) {
                            $(id).html(res);
                        },
                    });
                } else {
                    $(id).html(retorno);
                }
            },
        });
    });

     $(".js-campo-customizado-texto", context).on("change", function () { 
        if ($(this).val().length > 250) {
            let texto = $(this).val();
            texto = texto.substring(0, 250);
            $(this).val(texto);
        }
     });

    function getTiposCCL(modal) {
        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl("/painel/oportunidades/ccl/calculadora/tipos"),
            type: "get",
            data: {
                oportunidade_id: $("input[name='oportunidade_id']").val(),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (!res.erro) {
                    $(modal).find("select[name='tipo_ccl']").html("");
                    let options = res.dados;
                    $(options).each(function (index, option) {
                        $(modal).find("select[name='tipo_ccl']").append(`
                                <option value="${option.id}">${option.nome}</option>
                            `);
                    });
                }
            },
        });
    }

    function getBasesCCL(modal) {
        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl("/painel/oportunidades/ccl/calculadora/bases"),
            type: "get",
            data: {
                oportunidade_id: $("input[name='oportunidade_id']").val(),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (!res.erro) {
                    $(modal).find("select[name='base_ccl']").html("");
                    let options = res.dados;
                    $(options).each(function (index, option) {
                        $(modal).find("select[name='base_ccl']").append(`
                                <option value="${option.id}">${option.nome}</option>
                            `);
                    });
                }
            },
        });
    }

    function isIntString(str) {

        return /^\d+$/.test(str);
    }

    function getDadosCalculadoraCCL(modal) {
        let altura = $(modal).find("input[name='altura_ccl']").val();
        let idBase = $(modal).find("select[name='base_ccl']").val();
        let idPeriodoLocacao = $(modal).find("select[name='periodo_ccl']").val();
        let idTipoCalculadora = $(modal).find("select[name='tipo_ccl']").val();
        let quantidadeTorre = $(modal).find("input[name='torre_ccl']").val();
        let oportunidadeId = $("input[name='oportunidade_id']").val();

        if (isEmpty(altura) || isEmpty(quantidadeTorre)) {
            showToastDanger(
                $("body"),
                "Você precisa preencher a altura e a base"
            );
            return;
        }

        if (
            limpaMoeda(quantidadeTorre) > 999999999 ||
            limpaMoeda(altura) > 999999999
        ) {
            showToastDanger(
                $("body"),
                "Você precisa preencher a altura e a base corretamente, verifique os valores digitados"
            );
            return;
        }

        if (!isIntString(limpaMoeda(altura))) {
            showToastDanger(
                $("body"),
                "Você precisa preencher a altura com um número inteiro"
            );
            return;
        }

        $(".js-produtos-ccl").html("");
        $("#overlayer-loading").addClass("show-overlayer");

        $.ajax({
            url: siteUrl("/painel/oportunidades/ccl/calculadora/resultado"),
            type: "get",
            data: {
                altura: altura,
                idBase: idBase,
                idPeriodoLocacao: idPeriodoLocacao,
                idTipoCalculadora: idTipoCalculadora,
                quantidadeTorre: quantidadeTorre,
                oportunidade_id: oportunidadeId,
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (!res.erro) {
                    let equipamentos = res.dados;
                    $(equipamentos).each(function (index, equipamento) {
                        let total =
                            equipamento.quantidade * equipamento.valorUnitario;
                        let totalBrl = total.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                        });
                        let valorUnitarioBrl =
                            equipamento.valorUnitario.toLocaleString("pt-br", {
                                style: "currency",
                                currency: "BRL",
                            });
                        let quantidadeBrl =
                            equipamento.quantidade.toLocaleString("pt-br");
                        /*($(equipamento.periodosLocacao).each(function(index, periodo) {

                                periodo.descricao;
                                periodo.dias;
                                periodo.id;
                                periodo.valor;
                                periodo.valorNegociado;
                            });*/
                        $(".js-produtos-ccl").append(`
                            <tr class="tr-produtos-ccl tr-produtos-ccl-selecionado">
                                <td>
                                    ${equipamento.idEquipamentoNoCcl}
                                    <input
                                        type="checkbox"
                                        checked=""checked
                                        name="js-checkbox-dados-produtos-ccl[]"
                                        class="invisible"
                                        data-codigo="${equipamento.idEquipamentoNoCcl}"
                                        data-descricao="${equipamento.nome}"
                                        data-quantidade="${equipamento.quantidade}"
                                        data-unitario="${equipamento.valorUnitario}"
                                        data-total="${total}"
                                    >
                                </td>
                                <td>${equipamento.nome}</td>
                                <td>${quantidadeBrl}</td>
                                <td>${valorUnitarioBrl}</td>
                                <td>${totalBrl}</td>
                            </tr>`);
                    });
                } else {
                    showToastDanger(context, res.mensagem);
                }
            },
        });
    }

    $(context).on("click", ".tr-produtos-ccl", function () {

        if (!$(this).hasClass("tr-produtos-ccl-selecionado")) {

            $(this).removeClass("tr-produtos-ccl-nao-selecionado");
            $(this).addClass("tr-produtos-ccl-selecionado");
            $("input[name='js-checkbox-dados-produtos-ccl[]']", this).prop('checked', true);
        } else {

            $(this).addClass("tr-produtos-ccl-nao-selecionado");
            $(this).removeClass("tr-produtos-ccl-selecionado");
            $("input[name='js-checkbox-dados-produtos-ccl[]']", this).prop('checked', false);
        }

    });

    $(".js-salvar-produtos-ccl", context).on("click", function () {
        const modal = $(this).closest(".modal");
        let oportunidade_id = $("input[name='oportunidade_id']").val();
        let periodo = $(modal).find("select[name='periodo_ccl']").val();
        let dados = $(modal).find(
            "input[name='js-checkbox-dados-produtos-ccl[]']:checked"
        );
        let dadosJson = [];

        if (dados.length < 1) {
            showToastDanger(context, 'Você precisa selecionar pelo menos um produto');
            return;
        }

        dados.toArray().forEach(function (element) {
            dadosJson.push($(element).data());
        });

        $.ajax({
            url: siteUrl(`/painel/oportunidades/ccl/calculadora/produtos`),
            type: "post",
            data: {
                oportunidade_id,
                periodo,
                dadosJson,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                if (!res.erro) {
                    showToastSuccess(context, res.mensagem);
                    window.location.reload(true);
                } else {
                    showToastDanger(context, res.mensagem);
                    window.location.reload(true);
                }
            },
            error: function (err) {
                showToastDanger(
                    context,
                    "Ocorreu um erro ao tentar incluir os produtos"
                );
            },
        });
    });

    $(".js-calculadora-andaime-ccl", context).on("click", function () {
        const modal = $(this, context).attr("data-target");
        getTiposCCL(modal);
        getBasesCCL(modal);
    });

    $(".js-botao-calcular-calculadora-andaime-ccl", context).on("click", function () {
        const modal = $(this).closest(".modal");
        getDadosCalculadoraCCL(modal);
    });

    $(".js-pegar-oportunidade", context).on('click', function () {

        const idOportunidade = $(".id-oportunidade").val();
        $.ajax({
            url: siteUrl(`/painel/oportunidades/pegar-oportunidade`),
            type: "PUT",
            data: {
                id_oportunidade: idOportunidade,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                    "content"
                ),
            },
            success: function (res) {
                if (res.erro) {

                    showToastDanger(context, res.mensagem);
                    window.location.reload(true);
                } else {

                    showToastSuccess(context, res.mensagem);
                    window.location.reload(true);
                }
            },
            error: function (res) {

                showToastDanger(context, res.mensagem);
            },
        });

    });

    function showOnlyFirstProtocolElements() {
        const protocols = {};

        $("[starting-protocol]:visible").each(function () {
            const $element = $(this);
            const protocolId = $element.attr("starting-protocol");

            if (!protocols[protocolId]) {
                protocols[protocolId] = true;
                $element.show();
            } else {
                $element.hide();
            }
        });
    }

    let triggerSrollChatEnabled = true;

    function elocaScrollChatParaMensagensNaoLidas(containerChat) {
        if (!containerChat || !containerChat.length) {
            return;
        }
        const params = new URLSearchParams(window.location.search);
        if (params.get("focus_chat") !== "1" && !params.get("msg_nao_lida_id")) {
            return;
        }
        setTimeout(function () {
            let target = containerChat.find(".bloco-msg-nao-lida").first();
            if (!target.length) {
                const msgId = params.get("msg_nao_lida_id");
                if (msgId) {
                    target = containerChat.find("#js-mensagem-" + msgId);
                }
            }
            if (target.length) {
                const scrollTop = target[0].offsetTop - 48;
                containerChat.scrollTop(Math.max(0, scrollTop));
            } else {
                containerChat.scrollTop(containerChat.prop("scrollHeight"));
            }
        }, 250);
    }

    function loadingChat(elementTab, containerChat) {
        let configId = elementTab.data("config-id");
        let page = elementTab.data("page");
        let isLoading = parseInt(elementTab.data("loading"));
        let protocolosIds = elementTab.data("protocolos-ids") ?? null;

        if (isLoading == 1 || (containerChat == undefined && page > 0)) {
            return;
        }

        triggerSrollChatEnabled = true;

        elementTab.data("loading", 1);
        $(".js-container-chat-loading").removeClass("d-none");
        let tipoIntegracao = elementTab.data("tipo-integracao") ?? null;
        //alert(tipoIntegracao);
        $.ajax({
            url: siteUrl(`/painel/oportunidades/load-chat`),
            type: "get",
            data: {
                config_id: configId,
                oportunidade_id: elementTab.data("oportunidade-id"),
                protocols: protocolosIds,
                page: page,
                tipo_integracao: tipoIntegracao,
            },
            success: function (res) {
                $(".js-container-chat-loading").addClass("d-none");
                let scrollHeight = containerChat
                    ? containerChat.prop("scrollHeight")
                    : null;

                if (res.success == true) {
                    elementTab.find(".js-container-chat-body").prepend(res.html);
                    elementTab.data("page", page + 1);
                    elementTab.data("loading", 0);
                    if (res?.protocols != null) {
                        elementTab.data("protocolos-ids", res.protocols.join(','));
                    }
                    showOnlyFirstProtocolElements();
                    if (page == 0) {
                        const newContext = $(
                            $(".js-aba-chat.active", context).data("tab"),
                            context
                        );
                        functions.calculaAlturaScroll(newContext);
                        const chatScroll =
                            containerChat || elementTab.find(".js-container-chat");
                        elocaScrollChatParaMensagensNaoLidas(chatScroll);
                    } else {
                        if (scrollHeight != null && triggerSrollChatEnabled) {
                            let currentScrollHeight =
                                containerChat.prop("scrollHeight");
                            containerChat.scrollTop(
                                currentScrollHeight - scrollHeight
                            );
                        }
                    }

                    $(".js-container-chat").trigger("scroll");
                } else {
                    elementTab.data("loading", 0);
                }
            },
            error: function (err) {
                console.log("err", err);
                elementTab.data("loading", 0);
                showToastDanger(context, "Ops, erro ao tentar carregar o chat.");
                $(".js-container-chat-loading").addClass("d-none");
            },
        });
    }

    $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        let tabId = $(e.target).attr("href");
        let element = $(tabId);
        let isAtivo = element.hasClass("active");
        let isChat = element.hasClass("js-tab-chat");
        if (isAtivo && isChat) {
            loadingChat(element);
        }
    });

    $(".js-container-chat").on("scroll", function () {
        triggerSrollChatEnabled = false;
        let containerChat = $(this);
        let element = containerChat.parents(".tab-pane.js-tab-chat");
        let isAtivo = element.hasClass("active");
        let isChat = element.hasClass("js-tab-chat");

        if (isAtivo && isChat) {
            let scrollTop = containerChat.scrollTop();
            if (scrollTop == 0) {
                loadingChat(element, containerChat);
            }
        }
    });

    $('body').on('click', ".js-chat-mensagem", function () {
        const chatId = $(".js-show-popover-reagir", this).data("chat-id");
        $(".js-show-popover-reagir", context).not(`[data-chat-id=${chatId}]`).popover("hide");
        $(".js-reacoes-bloco", context).addClass("d-none");
        $(".js-emoji-list", context).removeClass("d-none");
    });

    $('body').on('click', ".js-show-popover-reagir", function () {
        $(this, context).popover("show");
        const chatId = $(this).data("chat-id");

        const todasReacoes = $("#js-cache-todas-reacoes").html();
        $(`.js-bloco-reacoes-${chatId}.js-bloco-todas-reacoes`).html(todasReacoes);

        $(`.js-emoji-list-${chatId}`).unbind("click");
        $(`.js-emoji-list-${chatId}`).on("click", function () {
            $(`.js-bloco-reacoes-${chatId}.js-bloco-todas-reacoes`).removeClass("d-none");
            $(this).addClass("d-none");
        });

        $(`.js-bloco-reacoes-${chatId} .js-icone-reacao`).unbind("click");
        $(`.js-bloco-reacoes-${chatId} .js-icone-reacao`).on("click", function () {
            const emoji = $(this).html();
            const chatId = $(this).closest(".js-bloco-reacoes").prop("id");

            $(".js-show-popover-reagir", context).popover("hide");
            $.post({
                url: siteUrl(`/painel/chat/reagir/${chatId}`),
                type: "post",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
                },
                data: {
                    chatId,
                    emoji
                },
                success: function (response) {
                    if (response.error) {
                        showToastDanger(context, response.message)
                    } else {
                        $(`#js-mensagem-${chatId}`).addClass("com-reacao");
                        $(`#js-mensagem-${chatId} .js-mensagem-reacao`).removeClass("d-none");
                        $(`#js-mensagem-${chatId} .js-mensagem-reacao .js-reacao-user`).html(emoji);
                        showToastSuccess(context, response.message);
                    }
                },
                error: function (error) {
                    showToastDanger(context, 'Não foi possível enviar a reação, tente novamente.')
                }
            })
        });
    });

    $(".js-arquivo-ws-tentar-novamente", context).on("click", function () {
        const eventoId = $(this).data("evento-id");
        $.ajax({
            url: siteUrl(`/painel/whatsapp-websocket-eventos/processar-ajax/${eventoId}`),
            type: "get",
            success: function (res) {
                if (!res.erro) {
                    showToastSuccess(context, res.mensagem);
                } else {
                    showToastDanger(context, res.mensagem);
                }
            },
        });
    });

    $(".js-vericar-tarefas-abertas").on('click', function() {
        $("#overlayer-loading").addClass("show-overlayer");
        const oportunidadeId = $("input[name='id']").val()
        $.ajax({
            url: siteUrl(`/painel/oportunidades/tarefas-abertas/${oportunidadeId}`),
            type: "get",
            success: function (res) {
                if(res.total_tarefas > 0) {
                    $("#avisoTarefaModal").modal();
                } else {
                    $("#encerrarAtendimento").modal();
                }

                $("#overlayer-loading").removeClass("show-overlayer");
            },
             error: function (error) {
                showToastDanger(context, 'Falha ao verificar as tarefas em aberto.')
            }
        });
    });

    $(".js-modal-aprovar-oportunidade").on("click", function() {
        $("#aprovarOportunidadeModal").modal('show');
    });

    $(".js-aprovar-oportunidade").on("click", function() {
        $("#overlayer-loading").addClass("show-overlayer");
        const oportunidadeId = $("input[name='id']").val();
        $.ajax({
            url: siteUrl(`/painel/oportunidades/aprovar/${oportunidadeId}`),
            type: "put",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                showToastSuccess(context, res.message);
                $("#overlayer-loading").removeClass("show-overlayer");
                window.location.reload(true);
            },
             error: function (error) {
                showToastDanger(context, error.message);
                $("#overlayer-loading").removeClass("show-overlayer");
            }
        });
    });

    $(".js-buscar-ultimos-produtos-cliente").on("click", function() {
        const clienteId = $(this).data("cliente-id");
        const oportunidadeId = $(this).data("oportunidade-id");
        
        $('#modalUltimosProdutosCliente').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        
        if (!clienteId) {
            showToastDanger(context, 'ID do cliente não encontrado.');
            return;
        }

        $("#overlayer-loading").addClass("show-overlayer");
        
        $.ajax({
            url: siteUrl(`/painel/oportunidades/ultimos-produtos-cliente/${clienteId}/${oportunidadeId}`),
            type: "get",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                
                if (res.success && res.produtos.length > 0) {
                    mostrarModalProdutosCliente(res.produtos, oportunidadeId);
                } else {
                    showToastWarning(context, 'Nenhum produto encontrado no histórico do cliente.');
                }
            },
            error: function (error) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context, 'Erro ao buscar produtos do cliente.');
            }
        });
    });

    function mostrarModalProdutosCliente(produtos, oportunidadeId) {
        const modalId = '#modalUltimosProdutosCliente';
        
        if ($(modalId).length) {
            $(modalId).modal('hide');
            $(modalId).off();
            $(modalId).remove();
        }
        
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        
        setTimeout(function() {
            criarEExibirModal(produtos, oportunidadeId, modalId);
        }, 100);
    }

    function criarEExibirModal(produtos, oportunidadeId, modalId) {
        
        const modalHtml = `
            <div class="modal fade" id="modalUltimosProdutosCliente" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Últimos Produtos do Cliente</h5>
                            <button type="button" class="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p class="text-muted mb-3">Selecione os produtos que deseja adicionar à oportunidade:</p>
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th width="40" class="text-center">
                                                <input type="checkbox" id="selectAll" class="form-check-input" style="position: relative !important;">
                                            </th>
                                            <th>SKU</th>
                                            <th>Nome</th>
                                            <th>Último Preço</th>
                                            <th>Origem</th>
                                        </tr>
                                    </thead>
                                    <tbody id="produtosTableBody">
                                        ${produtos.map(produto => `
                                            <tr>
                                                <td class="text-center">
                                                    <input type="checkbox" 
                                                           class="form-check-input produto-checkbox" 
                                                           value="${produto.id}" 
                                                           data-produto-id="${produto.id}"
                                                           data-produto-nome="${produto.nome.replace(/"/g, '&quot;')}"
                                                           data-produto-sku="${produto.sku || ''}"
                                                           data-produto-preco="${produto.preco || 0}"
                                                           data-produto-tipo="${produto.tipo}"
                                                           style="position: relative !important;">
                                                </td>
                                                <td>${produto.sku || '-'}</td>
                                                <td>${produto.nome}</td>
                                                <td>R$ ${parseFloat(produto.preco || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</td>
                                                <td>
                                                    <span class="badge badge-${getBadgeColor(produto.tipo)}">${getTipoLabel(produto.tipo)}</span>
                                                </td>
                                            </tr>
                                        `).join('')}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <button type="button" class="btn btn-primary" id="adicionarProdutosSelecionados">
                                Adicionar Selecionados
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        $('body').append(modalHtml);
        
        $(modalId).on('hidden.bs.modal', function () {
            $(this).off();
            $(this).remove();
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
        });
        
        $(modalId).modal({
            backdrop: 'static',
            keyboard: true
        }).modal('show');
        
        setupModalEventListeners(modalId, oportunidadeId);
    }

    function setupModalEventListeners(modalId, oportunidadeId) {
        $(modalId).find('#selectAll').on('change', function() {
            const isChecked = $(this).is(':checked');
            $(modalId).find('.produto-checkbox').prop('checked', isChecked);
        });
        
        $(modalId).find('#adicionarProdutosSelecionados').on('click', function() {
            const produtosSelecionados = [];
            
            $(modalId).find('.produto-checkbox:checked').each(function() {
                const produto = {
                    id: $(this).data('produto-id'),
                    nome: $(this).data('produto-nome'),
                    sku: $(this).data('produto-sku'),
                    preco: $(this).data('produto-preco'),
                    tipo: $(this).data('produto-tipo')
                };
                produtosSelecionados.push(produto);
            });
            
            if (produtosSelecionados.length === 0) {
                showToastDanger(context, 'Selecione pelo menos um produto.');
                return;
            }
            
            adicionarProdutosAOportunidade(produtosSelecionados, oportunidadeId, modalId);
        });
    }

    function adicionarProdutosAOportunidade(produtos, oportunidadeId, modalId) {
        $("#overlayer-loading").addClass("show-overlayer");
        
        let produtoIndex = 0;
        
        function adicionarProximoProduto() {
            if (produtoIndex >= produtos.length) {
                $("#overlayer-loading").removeClass("show-overlayer");
                
                $(modalId).modal('hide');
                setTimeout(function() {
                    $(modalId).remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                }, 300);
                
                showToastSuccess(context, `${produtos.length} produto(s) adicionado(s) com sucesso!`);
                
                setTimeout(function() {
                    window.location.reload();
                }, 500);
                return;
            }
            
            const produto = produtos[produtoIndex];
            
            $.ajax({
                url: siteUrl("/painel/oportunidades/adicionar-produto"),
                type: "post",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
                },
                data: {
                    produto_id: produto.id,
                    oportunidade_id: oportunidadeId,
                    quantidade: 1,
                },
                success: function (res) {
                    if (res.error) {
                        console.warn(`Erro ao adicionar produto ${produto.nome}: ${res.message}`);
                    }
                    
                    produtoIndex++;
                    adicionarProximoProduto();
                },
                error: function () {
                    console.warn(`Erro ao adicionar produto ${produto.nome}`);
                    
                    produtoIndex++;
                    adicionarProximoProduto();
                }
            });
        }
        
        adicionarProximoProduto();
    }

    function getBadgeColor(tipo) {
        switch(tipo) {
            case 'pedido': return 'success';
            case 'assinatura': return 'info';
            case 'oportunidade': return 'warning';
            case 'orcamento': return 'primary';
            case 'oservico': return 'danger';
            case 'proposta': return 'dark';
            default: return 'secondary';
        }
    }

    function getTipoLabel(tipo) {
        switch(tipo) {
            case 'pedido': return 'Pedido';
            case 'assinatura': return 'Assinatura';
            case 'oportunidade': return 'Oportunidade';
            case 'orcamento': return 'Orçamento';
            case 'oservico': return 'Ordem de Serviço';
            case 'proposta': return 'Proposta';
            default: return 'Outros';
        }
    }


    $(".js-enviar-erp", context).on("click", function () {
        $("#overlayer-loading").addClass("show-overlayer");
        let oportunidadeId = $("input[name='oportunidade_id']").val();
        $("#modalConfirmaDadosERP").modal('hide');
        $.ajax({
            url: siteUrl(`/painel/oportunidades/enviar-erp/${oportunidadeId}`),
            type: "post",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (res.success) {
                    showToastSuccess(context, res.message);
                }
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(
                    context,
                    err.responseJSON?.message ??
                    "Não enviado."
                );
            },
        });
    });

    $(".js-enviar-orcamento-erp", context).on("click", function () {
        $("#overlayer-loading").addClass("show-overlayer");
        let oportunidadeId = $("input[name='oportunidade_id']").val();
        $("#modalConfirmaOrcamentoERP").modal("hide");
        $.ajax({
            url: siteUrl(
                `/painel/oportunidades/enviar-orcamento-erp/${oportunidadeId}`
            ),
            type: "post",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (res.error) {
                    showToastDanger(
                        context,
                        res.message ?? "Não foi possível enviar o orçamento."
                    );
                    return;
                }
                const orcamento = res.data?.orcamento ?? res.data?.data?.orcamento;
                showToastSuccess(
                    context,
                    res.message +
                        (orcamento ? " Orçamento nº " + orcamento + "." : "")
                );
                if (orcamento) {
                    $('.js-orcamento-erp-enviar', context).replaceWith(
                        '<button type="button" class="btn btn-depth btn-outline-secondary btn-sm mr-1 btn-orcamento-erp-numero js-orcamento-erp-numero" disabled ' +
                        'title="Número do orçamento no ERP: ' + orcamento + '">' +
                        '<i class="fas fa-file-invoice-dollar mr-1"></i>' +
                        'ERP #' + orcamento +
                        '</button>'
                    );
                }
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(
                    context,
                    err.responseJSON?.message ??
                        "Não foi possível enviar o orçamento."
                );
            },
        });
    });

    $(context).on("click", ".js-baixar-modelo-orcamento", function (e) {
        e.preventDefault();
        const modeloId = $(this).data("modelo");
        const oportunidadeId = $(this).data("oportunidade");
        const $container = $("#IframeModeloOrcamentoConteudo");
        const loadingHtml =
            '<div class="loading-circle"><div></div><div></div><div></div><div></div></div>';

        $(".js-btn-download-docx").attr("href", siteUrl(`/painel/oportunidades/gerar-documento/${oportunidadeId}/${modeloId}?format=docx`));
        $container.html(loadingHtml);
        $("#modalBaixarModeloOrcamento").modal("show");

        $.ajax({
            url: siteUrl(
                `/painel/oportunidades/gerar-documento/${oportunidadeId}/${modeloId}`
            ),
            type: "GET",
            dataType: "json",
            headers: {
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            success: function (res) {
                if (!res.success) {
                    $("#modalBaixarModeloOrcamento").modal("hide");
                    showToastDanger(
                        context,
                        res.message || "Falha ao gerar o arquivo."
                    );
                    return;
                }
                const fileUrl = String(res.file_url || "").trim();
                $("#orcamento-pdf-nome").val(res.filename);
                if (!fileUrl) {
                    $("#modalBaixarModeloOrcamento").modal("hide");
                    showToastDanger(
                        context,
                        "Arquivo de orçamento vazio ou inválido."
                    );
                    return;
                }
                if (res.preview_fallback) {
                    $container.html(
                        '<div class="alert alert-info m-3 mb-0">' +
                            "Preview em PDF indisponível sem " +
                            "<code>DOCX_TO_PDF_CONVERT_TOKEN</code> no .env. " +
                            "Use <strong>Download DOCX</strong> para abrir o arquivo gerado." +
                            "</div>"
                    );
                    return;
                }
                $container.html(
                    '<iframe title="Orçamento" src="' +
                        fileUrl +
                        '" data-pdf-url="' +
                        fileUrl +
                        '" style="width:100%;min-height:70vh;border:0;" id="iframe-modelo-orcamento"></iframe>'
                );
            },
            error: function (xhr) {
                $("#modalBaixarModeloOrcamento").modal("hide");
                showToastDanger(
                    context,
                    xhr.responseJSON?.message ??
                        "Não foi possível gerar o arquivo de orçamento."
                );
            },
        });
    });

    $("#modalBaixarModeloOrcamento")
        .off("hidden.bs.modal.elocaPdf")
        .on("hidden.bs.modal.elocaPdf", function () {
            $("#IframeModeloOrcamentoConteudo").html(
                '<div class="loading-circle"><div></div><div></div><div></div><div></div></div>'
            );
        });

    $(".js-escolher-config-pdf", context).on("click", function () {
        const configId = $("#config_modelo_pdf").val();
        const fileName =
            ($("#orcamento-pdf-nome").val() || "").trim() ||
            `orcamento-${configId}.pdf`;

        const fileUrl =
            ($("#iframe-modelo-orcamento").attr("data-pdf-url") || "").trim() ||
            ($("#iframe-modelo-orcamento").attr("src") || "").trim();

        if (!fileUrl || fileUrl.indexOf("base64,") !== -1) {
            showToastDanger(
                context,
                "Nenhum PDF carregado para enviar."
            );
            return;
        }

        $("#escolherConfigDPF").modal("hide");
        $("#modalBaixarModeloOrcamento").modal("hide");
        $("#modalImprimirOportunidade").modal("hide");

        $(`#bloco-chat-tab-${configId}`, context).trigger("click");
        $(".js-input-chat", context).val(" ");

        fetch(fileUrl)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Falha ao baixar PDF.");
                }
                return response.blob();
            })
            .then(function (blob) {
                const pdfFile = new File([blob], fileName, {
                    type: "application/pdf",
                });
                const inputEl = $(`#input-file-chat-${configId}`, context)[0];
                if (!inputEl) {
                    showToastDanger(
                        context,
                        "Chat da configuração não encontrado."
                    );
                    return;
                }

                functions.uploadOtherFile(pdfFile, "file", inputEl);
            })
            .catch(function () {
                showToastDanger(
                    context,
                    "Não foi possível preparar o PDF para envio."
                );
            });
    });

    $(".js-fechar-modal-imprimir", context).on("click", function () {
        setTimeout(function() {
            $(".js-racerregar-modelo", context).trigger("click");
        }, 1000);
    });

    $('body').on(
        'click',
        '.js-kanban-oportunidade, .js-oportunidade-iframe-modal',
        function (e) {
            let id = $(this).data('id');
            if (!id) return;
            e.preventDefault();
            let href = siteUrl("/painel/oportunidades/" + id);
            let sep = href.indexOf('?') !== -1 ? '&' : '?';
            if (typeof window.elocaAbrirModalIframePainel === "function") {
                window.elocaAbrirModalIframePainel(href + sep + "kanban_modal=1");
            } else {
                window.location.href = href + sep + "kanban_modal=1";
            }
            return false;
        }
    );

    $(document).on("click", ".js-modal-delete-fase", function () {
        const faseId = $(this).data("fase-id");
        const rawCount = $(
            "#quantidade-oportunidades-fase-" + faseId,
        ).attr("data-count-fase");
        const totalOportunidades = parseInt(rawCount, 10) || 0;
        const $modal = $("#modalDeleteFase-" + faseId);
        if (!$modal.length) {
            return;
        }

        const $formGroup = $modal.find(".js-form-movimentar-oportunidades");
        const $select = $formGroup.find('select[name="destino_fase_id"]');
        const $instrucao = $modal.find(".js-aviso-instrucao-movimentacao-fase");
        const $irreversivel = $modal.find(".js-aviso-irreversivel");

        if (totalOportunidades > 0) {
            if ($formGroup.length) {
                $formGroup.removeClass("d-none");
                $select.prop("required", true);
            }
            $instrucao.removeClass("d-none");
            $irreversivel.addClass("d-none");
        } else {
            if ($formGroup.length) {
                $formGroup.addClass("d-none");
                $select.prop("required", false);
            }
            $instrucao.addClass("d-none");
            $irreversivel.removeClass("d-none");
        }
    });


    $(document).on("hidden.bs.modal", "#modalOportunidadeFullscreen", function () {
        $("#iframeOportunidadeFullscreen").attr("src", "");
        if (typeof window.elocaModalIframePainelHideLoading === "function") {
            window.elocaModalIframePainelHideLoading(window.jQuery || window.$);
        }
        if ($(".modal.show").length) {
            $("body").addClass("modal-open");
        }
        // Não chamar encerrarConexaoWebSocketElocaHub() aqui: isso roda no window do pai e
        // derruba o WebSocket/bridge do Kanban (mesmos globals __elocaHub*). O iframe ao
        // perder o src encerra o JS do filho e suas conexões sozinho.
    }); 

    window.addEventListener("message", function (event) {
        const iframeEl = document.getElementById("iframeOportunidadeFullscreen");
        const data = event.data;

        if (
            data &&
            data.type === "elocaKanbanIframeNavigateStart" &&
            iframeEl &&
            iframeEl.contentWindow &&
            event.source === iframeEl.contentWindow &&
            $("#modalOportunidadeFullscreen").hasClass("show") &&
            typeof window.elocaModalIframePainelShowLoading === "function"
        ) {
            window.elocaModalIframePainelShowLoading(window.jQuery || window.$);
            return;
        }

        if (
            !iframeEl ||
            !iframeEl.contentWindow ||
            event.source !== iframeEl.contentWindow
        ) {
            return;
        }
        if (!data || data.type !== "elocaKanbanOportunidadeFechar") {
            return;
        }
        if (!$("#modalOportunidadeFullscreen").length) {
            return;
        }
        $("#iframeOportunidadeFullscreen").attr("src", "");
        $("#modalOportunidadeFullscreen").modal("hide");
    });
};
